import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_card_proto from './dcei_wildsky_card_proto';
class StoryEvent_EventLevel_LevelReward {
  get descriptor() {
    return StoryEvent_EventLevel_LevelReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_EventLevel_LevelReward) {
      return value;
    }
    return StoryEvent_EventLevel_LevelReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_EventLevel_LevelReward();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelReward(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelReward(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelReward(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelReward(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_EventLevel_LevelReward} other
   * @returns {StoryEvent_EventLevel_LevelReward}
   */
  merge(other) {
    const copy = new StoryEvent_EventLevel_LevelReward(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
StoryEvent_EventLevel_LevelReward.default = new StoryEvent_EventLevel_LevelReward();
class StoryEvent_EventLevel_LevelReward_Builder {
  constructor(value) {
    this._value = new StoryEvent_EventLevel_LevelReward(value);
  }
  build() {
    return new StoryEvent_EventLevel_LevelReward(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
StoryEvent_EventLevel_LevelReward.Builder = StoryEvent_EventLevel_LevelReward_Builder;
class StoryEvent_EventLevel_LevelReward_WithParent {
  /**
   * @param {StoryEvent_EventLevel_LevelReward} value
   * @param {StoryEvent_EventLevel_LevelReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_EventLevel_LevelReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new StoryEvent_EventLevel_LevelReward_WithParent(current, parent);
    return result;
  }
}
StoryEvent_EventLevel_LevelReward_WithParent.default = new StoryEvent_EventLevel_LevelReward_WithParent(StoryEvent_EventLevel_LevelReward.default, null);
StoryEvent_EventLevel_LevelReward.WithParent = StoryEvent_EventLevel_LevelReward_WithParent;
class StoryEvent_EventLevel_LevelReward_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_EventLevel_LevelReward.descriptor = new StoryEvent_EventLevel_LevelReward_Descriptor();
class StoryEvent_EventLevel_LevelInfo {
  get descriptor() {
    return StoryEvent_EventLevel_LevelInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasDifficulty = false;
    this._difficulty = null;
    this._silverStarReward = [];
    this._goldStarReward = [];
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasDifficulty) return false;
    if (this._silverStarReward.length > 0) return false;
    if (this._goldStarReward.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_EventLevel_LevelInfo) {
      return value;
    }
    return StoryEvent_EventLevel_LevelInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_EventLevel_LevelInfo();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    result._silverStarReward = JsonToList(json.silverStarReward, StoryEvent_EventLevel_LevelReward);
    result._goldStarReward = JsonToList(json.goldStarReward, StoryEvent_EventLevel_LevelReward);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._silverStarReward.length > 0) {
      result.silverStarReward = ArrayToJson(this._silverStarReward, StoryEvent_EventLevel_LevelReward);
    }
    if (this._goldStarReward.length > 0) {
      result.goldStarReward = ArrayToJson(this._goldStarReward, StoryEvent_EventLevel_LevelReward);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {StoryEvent_EventLevel_LevelReward[]}
   */
  get silverStarReward() {
    return this._silverStarReward;
  }
  addSilverStarReward(path, value) {
    return {type: 'ADD', path: path.concat(['silverStarReward']), value: value.toJson()};
  }
  setSilverStarReward(path, value) {
    return {type: 'SET', path: path.concat(['silverStarReward']), value: ArrayToJson(value, StoryEvent_EventLevel_LevelReward)};
  }
  setSilverStarRewardByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['silverStarReward', key]), value: value.toJson()};
  }
  deleteSilverStarReward(path) {
    return {type: 'DELETE', path: path.concat(['silverStarReward'])};
  }
  deleteSilverStarRewardByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['silverStarReward', key])};
  }
  /**
   * @returns {StoryEvent_EventLevel_LevelReward[]}
   */
  get goldStarReward() {
    return this._goldStarReward;
  }
  addGoldStarReward(path, value) {
    return {type: 'ADD', path: path.concat(['goldStarReward']), value: value.toJson()};
  }
  setGoldStarReward(path, value) {
    return {type: 'SET', path: path.concat(['goldStarReward']), value: ArrayToJson(value, StoryEvent_EventLevel_LevelReward)};
  }
  setGoldStarRewardByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldStarReward', key]), value: value.toJson()};
  }
  deleteGoldStarReward(path) {
    return {type: 'DELETE', path: path.concat(['goldStarReward'])};
  }
  deleteGoldStarRewardByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldStarReward', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverStarReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = [];        for (let i of value) {
                copy._silverStarReward.push(StoryEvent_EventLevel_LevelReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.concat([StoryEvent_EventLevel_LevelReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._silverStarReward.length === 0) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._silverStarReward.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.slice();
              copy._silverStarReward[path[1]] = StoryEvent_EventLevel_LevelReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._silverStarReward = copy._silverStarReward.slice(0, path[1]).concat(copy._silverStarReward.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._silverStarReward.length) {
            return this;
          }
          const oldValue = this._silverStarReward[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_EventLevel_LevelInfo(this);
          copy._silverStarReward = copy._silverStarReward.slice();
          copy._silverStarReward[key] = newValue;
          return copy;
        }
      }
      case "goldStarReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = [];        for (let i of value) {
                copy._goldStarReward.push(StoryEvent_EventLevel_LevelReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.concat([StoryEvent_EventLevel_LevelReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldStarReward.length === 0) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldStarReward.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.slice();
              copy._goldStarReward[path[1]] = StoryEvent_EventLevel_LevelReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_EventLevel_LevelInfo(this);
              copy._goldStarReward = copy._goldStarReward.slice(0, path[1]).concat(copy._goldStarReward.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldStarReward.length) {
            return this;
          }
          const oldValue = this._goldStarReward[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_EventLevel_LevelInfo(this);
          copy._goldStarReward = copy._goldStarReward.slice();
          copy._goldStarReward[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_EventLevel_LevelInfo} other
   * @returns {StoryEvent_EventLevel_LevelInfo}
   */
  merge(other) {
    const copy = new StoryEvent_EventLevel_LevelInfo(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    copy._silverStarReward = this._silverStarReward.concat(other._silverStarReward);
    copy._goldStarReward = this._goldStarReward.concat(other._goldStarReward);
    return copy;
  }
}
StoryEvent_EventLevel_LevelInfo.default = new StoryEvent_EventLevel_LevelInfo();
class StoryEvent_EventLevel_LevelInfo_Builder {
  constructor(value) {
    this._value = new StoryEvent_EventLevel_LevelInfo(value);
  }
  build() {
    return new StoryEvent_EventLevel_LevelInfo(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  addAllSilverStarReward(values) {
    this._value._silverStarReward = this._value._silverStarReward.concat(values);
    return this;
  }
  addSilverStarReward(value) {
    this._value._silverStarReward = this._value._silverStarReward.concat([value]);
    return this;
  }
  setSilverStarReward(index, value) {
    this._value._silverStarReward = this._value._silverStarReward.concat();
    this._value._silverStarReward[index] = value;
    return this;
  }
  clearSilverStarReward() {
    this._value._silverStarReward = [];
    return this;
  }
  addAllGoldStarReward(values) {
    this._value._goldStarReward = this._value._goldStarReward.concat(values);
    return this;
  }
  addGoldStarReward(value) {
    this._value._goldStarReward = this._value._goldStarReward.concat([value]);
    return this;
  }
  setGoldStarReward(index, value) {
    this._value._goldStarReward = this._value._goldStarReward.concat();
    this._value._goldStarReward[index] = value;
    return this;
  }
  clearGoldStarReward() {
    this._value._goldStarReward = [];
    return this;
  }
}
StoryEvent_EventLevel_LevelInfo.Builder = StoryEvent_EventLevel_LevelInfo_Builder;
class StoryEvent_EventLevel_LevelInfo_WithParent {
  /**
   * @param {StoryEvent_EventLevel_LevelInfo} value
   * @param {StoryEvent_EventLevel_LevelInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_EventLevel_LevelInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get selfSilverStarReward() {
    if (!this._selfSilverStarReward) {
      this._selfSilverStarReward = [];
      for (let i of this._value.silverStarReward) {
        this._selfSilverStarReward.push(new StoryEvent_EventLevel_LevelReward.WithParent(i, null));
      }
    }
    return this._selfSilverStarReward;
  }
  get inherentSilverStarReward() {
    if (!this._inherentSilverStarReward) {
      this._inherentSilverStarReward = this._parent ? this._parent.silverStarReward : [];
    }
    return this._inherentSilverStarReward;
  }
  get silverStarReward() {
    if (!this._allSilverStarReward) {
      this._allSilverStarReward = this._parent ? this._parent.silverStarReward.concat(this.selfSilverStarReward) : this.selfSilverStarReward;
    }
    return this._allSilverStarReward;
  }
  get selfGoldStarReward() {
    if (!this._selfGoldStarReward) {
      this._selfGoldStarReward = [];
      for (let i of this._value.goldStarReward) {
        this._selfGoldStarReward.push(new StoryEvent_EventLevel_LevelReward.WithParent(i, null));
      }
    }
    return this._selfGoldStarReward;
  }
  get inherentGoldStarReward() {
    if (!this._inherentGoldStarReward) {
      this._inherentGoldStarReward = this._parent ? this._parent.goldStarReward : [];
    }
    return this._inherentGoldStarReward;
  }
  get goldStarReward() {
    if (!this._allGoldStarReward) {
      this._allGoldStarReward = this._parent ? this._parent.goldStarReward.concat(this.selfGoldStarReward) : this.selfGoldStarReward;
    }
    return this._allGoldStarReward;
  }
  update(current, parent) {
    const result = new StoryEvent_EventLevel_LevelInfo_WithParent(current, parent);
    if (this._selfSilverStarReward) {
      if (this._value.silverStarReward === current.silverStarReward) {
        result._selfSilverStarReward = this._selfSilverStarReward;
      } else {
        result._selfSilverStarReward = [];
        for (let i = 0; i < current.silverStarReward.length; i++) {
          const oldValue = this._value.silverStarReward[i];
          if (oldValue) {
            const oldCache = this._selfSilverStarReward[i];
            if (oldValue === current.silverStarReward[i]) {
              result._selfSilverStarReward[i] = oldCache;
            } else {
              result._selfSilverStarReward[i] = oldCache.update(current.silverStarReward[i], null);
            }
          } else {
            result._selfSilverStarReward[i] = new StoryEvent_EventLevel_LevelReward.WithParent(current.silverStarReward[i], null);
          }
        }
      }
    }
    if (this._selfGoldStarReward) {
      if (this._value.goldStarReward === current.goldStarReward) {
        result._selfGoldStarReward = this._selfGoldStarReward;
      } else {
        result._selfGoldStarReward = [];
        for (let i = 0; i < current.goldStarReward.length; i++) {
          const oldValue = this._value.goldStarReward[i];
          if (oldValue) {
            const oldCache = this._selfGoldStarReward[i];
            if (oldValue === current.goldStarReward[i]) {
              result._selfGoldStarReward[i] = oldCache;
            } else {
              result._selfGoldStarReward[i] = oldCache.update(current.goldStarReward[i], null);
            }
          } else {
            result._selfGoldStarReward[i] = new StoryEvent_EventLevel_LevelReward.WithParent(current.goldStarReward[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEvent_EventLevel_LevelInfo_WithParent.default = new StoryEvent_EventLevel_LevelInfo_WithParent(StoryEvent_EventLevel_LevelInfo.default, null);
StoryEvent_EventLevel_LevelInfo.WithParent = StoryEvent_EventLevel_LevelInfo_WithParent;
class StoryEvent_EventLevel_LevelInfo_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 5,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get silverStarReward() {
    if (!this._silverStarReward) {
      this._silverStarReward = {
        name: "silverStarReward",
        Name: "SilverStarReward",
        number: 6,
        protoType: 11,
        protoName: "silver_star_reward",
        type: StoryEvent_EventLevel_LevelReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverStarReward;
  }
  get goldStarReward() {
    if (!this._goldStarReward) {
      this._goldStarReward = {
        name: "goldStarReward",
        Name: "GoldStarReward",
        number: 7,
        protoType: 11,
        protoName: "gold_star_reward",
        type: StoryEvent_EventLevel_LevelReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldStarReward;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.difficulty,
        this.silverStarReward,
        this.goldStarReward,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_EventLevel_LevelInfo.descriptor = new StoryEvent_EventLevel_LevelInfo_Descriptor();
class StoryEvent_EventLevel_SoloLevel {
  get descriptor() {
    return StoryEvent_EventLevel_SoloLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levels = [];
  }
  isEmpty() {
    if (this._levels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_EventLevel_SoloLevel) {
      return value;
    }
    return StoryEvent_EventLevel_SoloLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_EventLevel_SoloLevel();
    result._levels = JsonToList(json.levels, StoryEvent_EventLevel_LevelInfo);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, StoryEvent_EventLevel_LevelInfo);
    }
    return result;
  }
  /**
   * @returns {StoryEvent_EventLevel_LevelInfo[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, StoryEvent_EventLevel_LevelInfo)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_SoloLevel(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(StoryEvent_EventLevel_LevelInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.concat([StoryEvent_EventLevel_LevelInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new StoryEvent_EventLevel_SoloLevel(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = StoryEvent_EventLevel_LevelInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_EventLevel_SoloLevel(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_EventLevel_SoloLevel(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_EventLevel_SoloLevel} other
   * @returns {StoryEvent_EventLevel_SoloLevel}
   */
  merge(other) {
    const copy = new StoryEvent_EventLevel_SoloLevel(this);
    copy._levels = this._levels.concat(other._levels);
    return copy;
  }
}
StoryEvent_EventLevel_SoloLevel.default = new StoryEvent_EventLevel_SoloLevel();
class StoryEvent_EventLevel_SoloLevel_Builder {
  constructor(value) {
    this._value = new StoryEvent_EventLevel_SoloLevel(value);
  }
  build() {
    return new StoryEvent_EventLevel_SoloLevel(this._value);
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
}
StoryEvent_EventLevel_SoloLevel.Builder = StoryEvent_EventLevel_SoloLevel_Builder;
class StoryEvent_EventLevel_SoloLevel_WithParent {
  /**
   * @param {StoryEvent_EventLevel_SoloLevel} value
   * @param {StoryEvent_EventLevel_SoloLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_EventLevel_SoloLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new StoryEvent_EventLevel_LevelInfo.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  update(current, parent) {
    const result = new StoryEvent_EventLevel_SoloLevel_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new StoryEvent_EventLevel_LevelInfo.WithParent(current.levels[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEvent_EventLevel_SoloLevel_WithParent.default = new StoryEvent_EventLevel_SoloLevel_WithParent(StoryEvent_EventLevel_SoloLevel.default, null);
StoryEvent_EventLevel_SoloLevel.WithParent = StoryEvent_EventLevel_SoloLevel_WithParent;
class StoryEvent_EventLevel_SoloLevel_Descriptor {
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 1,
        protoType: 11,
        protoName: "levels",
        type: StoryEvent_EventLevel_LevelInfo,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
StoryEvent_EventLevel_SoloLevel.descriptor = new StoryEvent_EventLevel_SoloLevel_Descriptor();
class StoryEvent_EventLevel {
  get descriptor() {
    return StoryEvent_EventLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levels = [];
    this._soloLevels = [];
  }
  isEmpty() {
    if (this._levels.length > 0) return false;
    if (this._soloLevels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_EventLevel) {
      return value;
    }
    return StoryEvent_EventLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_EventLevel();
    result._levels = JsonToList(json.levels, StoryEvent_EventLevel_LevelInfo);
    result._soloLevels = JsonToList(json.soloLevels, StoryEvent_EventLevel_SoloLevel);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, StoryEvent_EventLevel_LevelInfo);
    }
    if (this._soloLevels.length > 0) {
      result.soloLevels = ArrayToJson(this._soloLevels, StoryEvent_EventLevel_SoloLevel);
    }
    return result;
  }
  /**
   * @returns {StoryEvent_EventLevel_LevelInfo[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, StoryEvent_EventLevel_LevelInfo)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  /**
   * @returns {StoryEvent_EventLevel_SoloLevel[]}
   */
  get soloLevels() {
    return this._soloLevels;
  }
  addSoloLevels(path, value) {
    return {type: 'ADD', path: path.concat(['soloLevels']), value: value.toJson()};
  }
  setSoloLevels(path, value) {
    return {type: 'SET', path: path.concat(['soloLevels']), value: ArrayToJson(value, StoryEvent_EventLevel_SoloLevel)};
  }
  setSoloLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['soloLevels', key]), value: value.toJson()};
  }
  deleteSoloLevels(path) {
    return {type: 'DELETE', path: path.concat(['soloLevels'])};
  }
  deleteSoloLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['soloLevels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(StoryEvent_EventLevel_LevelInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_EventLevel(this);
              copy._levels = copy._levels.concat([StoryEvent_EventLevel_LevelInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new StoryEvent_EventLevel(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = StoryEvent_EventLevel_LevelInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_EventLevel(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_EventLevel(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      case "soloLevels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel(this);
              copy._soloLevels = [];        for (let i of value) {
                copy._soloLevels.push(StoryEvent_EventLevel_SoloLevel.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.concat([StoryEvent_EventLevel_SoloLevel.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._soloLevels.length === 0) {
                return this;
              }
              const copy = new StoryEvent_EventLevel(this);
              copy._soloLevels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._soloLevels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.slice();
              copy._soloLevels[path[1]] = StoryEvent_EventLevel_SoloLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_EventLevel(this);
              copy._soloLevels = copy._soloLevels.slice(0, path[1]).concat(copy._soloLevels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._soloLevels.length) {
            return this;
          }
          const oldValue = this._soloLevels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_EventLevel(this);
          copy._soloLevels = copy._soloLevels.slice();
          copy._soloLevels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_EventLevel} other
   * @returns {StoryEvent_EventLevel}
   */
  merge(other) {
    const copy = new StoryEvent_EventLevel(this);
    copy._levels = this._levels.concat(other._levels);
    copy._soloLevels = this._soloLevels.concat(other._soloLevels);
    return copy;
  }
}
StoryEvent_EventLevel.default = new StoryEvent_EventLevel();
StoryEvent_EventLevel.LevelReward = StoryEvent_EventLevel_LevelReward;
StoryEvent_EventLevel.LevelInfo = StoryEvent_EventLevel_LevelInfo;
StoryEvent_EventLevel.SoloLevel = StoryEvent_EventLevel_SoloLevel;
class StoryEvent_EventLevel_Builder {
  constructor(value) {
    this._value = new StoryEvent_EventLevel(value);
  }
  build() {
    return new StoryEvent_EventLevel(this._value);
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
  addAllSoloLevels(values) {
    this._value._soloLevels = this._value._soloLevels.concat(values);
    return this;
  }
  addSoloLevels(value) {
    this._value._soloLevels = this._value._soloLevels.concat([value]);
    return this;
  }
  setSoloLevels(index, value) {
    this._value._soloLevels = this._value._soloLevels.concat();
    this._value._soloLevels[index] = value;
    return this;
  }
  clearSoloLevels() {
    this._value._soloLevels = [];
    return this;
  }
}
StoryEvent_EventLevel.Builder = StoryEvent_EventLevel_Builder;
class StoryEvent_EventLevel_WithParent {
  /**
   * @param {StoryEvent_EventLevel} value
   * @param {StoryEvent_EventLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_EventLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new StoryEvent_EventLevel_LevelInfo.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  get selfSoloLevels() {
    if (!this._selfSoloLevels) {
      this._selfSoloLevels = [];
      for (let i of this._value.soloLevels) {
        this._selfSoloLevels.push(new StoryEvent_EventLevel_SoloLevel.WithParent(i, null));
      }
    }
    return this._selfSoloLevels;
  }
  get inherentSoloLevels() {
    if (!this._inherentSoloLevels) {
      this._inherentSoloLevels = this._parent ? this._parent.soloLevels : [];
    }
    return this._inherentSoloLevels;
  }
  get soloLevels() {
    if (!this._allSoloLevels) {
      this._allSoloLevels = this._parent ? this._parent.soloLevels.concat(this.selfSoloLevels) : this.selfSoloLevels;
    }
    return this._allSoloLevels;
  }
  update(current, parent) {
    const result = new StoryEvent_EventLevel_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new StoryEvent_EventLevel_LevelInfo.WithParent(current.levels[i], null);
          }
        }
      }
    }
    if (this._selfSoloLevels) {
      if (this._value.soloLevels === current.soloLevels) {
        result._selfSoloLevels = this._selfSoloLevels;
      } else {
        result._selfSoloLevels = [];
        for (let i = 0; i < current.soloLevels.length; i++) {
          const oldValue = this._value.soloLevels[i];
          if (oldValue) {
            const oldCache = this._selfSoloLevels[i];
            if (oldValue === current.soloLevels[i]) {
              result._selfSoloLevels[i] = oldCache;
            } else {
              result._selfSoloLevels[i] = oldCache.update(current.soloLevels[i], null);
            }
          } else {
            result._selfSoloLevels[i] = new StoryEvent_EventLevel_SoloLevel.WithParent(current.soloLevels[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEvent_EventLevel_WithParent.default = new StoryEvent_EventLevel_WithParent(StoryEvent_EventLevel.default, null);
StoryEvent_EventLevel.WithParent = StoryEvent_EventLevel_WithParent;
class StoryEvent_EventLevel_Descriptor {
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 3,
        protoType: 11,
        protoName: "levels",
        type: StoryEvent_EventLevel_LevelInfo,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get soloLevels() {
    if (!this._soloLevels) {
      this._soloLevels = {
        name: "soloLevels",
        Name: "SoloLevels",
        number: 4,
        protoType: 11,
        protoName: "solo_levels",
        type: StoryEvent_EventLevel_SoloLevel,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soloLevels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levels,
        this.soloLevels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
StoryEvent_EventLevel.descriptor = new StoryEvent_EventLevel_Descriptor();
class StoryEvent_CardBoostInfo_BoostItem_CardItem {
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_CardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardUnit = false;
    this._cardUnit = null;
  }
  isEmpty() {
    if (this._hasCardUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CardBoostInfo_BoostItem_CardItem) {
      return value;
    }
    return StoryEvent_CardBoostInfo_BoostItem_CardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_CardItem();
    if (json.cardUnit != null) {
      result._hasCardUnit = true;
      result._cardUnit = JsonToString.fromJson(json.cardUnit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardUnit) {
      result.cardUnit = JsonToString.toJson(this._cardUnit);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get cardUnit() {
    return this._hasCardUnit ? this._cardUnit : JsonToString.default;
  }
  get hasCardUnit() {
    return this._hasCardUnit;
  }
  setCardUnit(path, value) {
    return {type: 'SET', path: path.concat(['cardUnit']), value};
  }
  deleteCardUnit(path) {
    return {type: 'DELETE', path: path.concat(['cardUnit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem_CardItem(this);
              copy._hasCardUnit = true;
              copy._cardUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardUnit) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem_CardItem(this);
              copy._hasCardUnit = false;
              copy._cardUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_CardItem} other
   * @returns {StoryEvent_CardBoostInfo_BoostItem_CardItem}
   */
  merge(other) {
    const copy = new StoryEvent_CardBoostInfo_BoostItem_CardItem(this);
    if (other._hasCardUnit) {
      copy._hasCardUnit = true;
      copy._cardUnit = other._cardUnit;
    }
    return copy;
  }
}
StoryEvent_CardBoostInfo_BoostItem_CardItem.default = new StoryEvent_CardBoostInfo_BoostItem_CardItem();
class StoryEvent_CardBoostInfo_BoostItem_CardItem_Builder {
  constructor(value) {
    this._value = new StoryEvent_CardBoostInfo_BoostItem_CardItem(value);
  }
  build() {
    return new StoryEvent_CardBoostInfo_BoostItem_CardItem(this._value);
  }
  setCardUnit(value) {
    this._value._hasCardUnit = true;
    this._value._cardUnit = value;
    return this;
  }
  deleteCardUnit() {
    this._value._hasCardUnit = false;
    this._value._cardUnit = null;
    return this;
  }
}
StoryEvent_CardBoostInfo_BoostItem_CardItem.Builder = StoryEvent_CardBoostInfo_BoostItem_CardItem_Builder;
class StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent {
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_CardItem} value
   * @param {StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_CardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardUnit() {
    if (this._cachedHasCardUnit === undefined) {
      if (this._value.hasCardUnit) {
        this._cachedHasCardUnit = true;
      } else {
        this._cachedHasCardUnit = this._parent ? this._parent.hasCardUnit : false;
      }
    }
    return this._cachedHasCardUnit;
  }
  get cardUnit() {
    if (this._cachedCardUnit === undefined) {
      if (this._value.hasCardUnit) {
        this._cachedCardUnit = this._value.cardUnit;
      } else {
        this._cachedCardUnit = this._parent ? this._parent.cardUnit : this._value.cardUnit;
      }
    }
    return this._cachedCardUnit;
  }
  update(current, parent) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent(current, parent);
    return result;
  }
}
StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent.default = new StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent(StoryEvent_CardBoostInfo_BoostItem_CardItem.default, null);
StoryEvent_CardBoostInfo_BoostItem_CardItem.WithParent = StoryEvent_CardBoostInfo_BoostItem_CardItem_WithParent;
class StoryEvent_CardBoostInfo_BoostItem_CardItem_Descriptor {
  get cardUnit() {
    if (!this._cardUnit) {
      this._cardUnit = {
        name: "cardUnit",
        Name: "CardUnit",
        number: 1,
        protoType: 9,
        protoName: "card_unit",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardUnit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardUnit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardUnit",
        Name: "DummyOneofForCardUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_CardBoostInfo_BoostItem_CardItem.descriptor = new StoryEvent_CardBoostInfo_BoostItem_CardItem_Descriptor();
class StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PHYSICAL": return 0;
        case "FIRE": return 1;
        case "WATER": return 2;
        case "NATURE": return 3;
        case "LIGHT": return 4;
        case "DARK": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(value);
  }
  static fromReact(e) {
    return StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(e);
  }
}
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.PHYSICAL = 0;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.FIRE = 1;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.WATER = 2;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.NATURE = 3;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.LIGHT = 4;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.DARK = 5;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.default = 0;
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.values = {
  PHYSICAL: 0,
  FIRE: 1,
  WATER: 2,
  NATURE: 3,
  LIGHT: 4,
  DARK: 5,
};
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.names = {
  0: "PHYSICAL",
  1: "FIRE",
  2: "WATER",
  3: "NATURE",
  4: "LIGHT",
  5: "DARK",
};
class StoryEvent_CardBoostInfo_BoostItem_AffinityItem {
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemAffinity = false;
    this._itemAffinity = null;
  }
  isEmpty() {
    if (this._hasItemAffinity) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CardBoostInfo_BoostItem_AffinityItem) {
      return value;
    }
    return StoryEvent_CardBoostInfo_BoostItem_AffinityItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem();
    if (json.itemAffinity != null) {
      result._hasItemAffinity = true;
      result._itemAffinity = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromJson(json.itemAffinity);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemAffinity) {
      result.itemAffinity = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.toJson(this._itemAffinity);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get itemAffinity() {
    return this._hasItemAffinity ? this._itemAffinity : StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.default;
  }
  get hasItemAffinity() {
    return this._hasItemAffinity;
  }
  setItemAffinity(path, value) {
    return {type: 'SET', path: path.concat(['itemAffinity']), value};
  }
  deleteItemAffinity(path) {
    return {type: 'DELETE', path: path.concat(['itemAffinity'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemAffinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem(this);
              copy._hasItemAffinity = true;
              copy._itemAffinity = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemAffinity) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem(this);
              copy._hasItemAffinity = false;
              copy._itemAffinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_AffinityItem} other
   * @returns {StoryEvent_CardBoostInfo_BoostItem_AffinityItem}
   */
  merge(other) {
    const copy = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem(this);
    if (other._hasItemAffinity) {
      copy._hasItemAffinity = true;
      copy._itemAffinity = other._itemAffinity;
    }
    return copy;
  }
}
StoryEvent_CardBoostInfo_BoostItem_AffinityItem.default = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem();
StoryEvent_CardBoostInfo_BoostItem_AffinityItem.Affinity = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity;
class StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Builder {
  constructor(value) {
    this._value = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem(value);
  }
  build() {
    return new StoryEvent_CardBoostInfo_BoostItem_AffinityItem(this._value);
  }
  setItemAffinity(value) {
    this._value._hasItemAffinity = true;
    this._value._itemAffinity = value;
    return this;
  }
  deleteItemAffinity() {
    this._value._hasItemAffinity = false;
    this._value._itemAffinity = null;
    return this;
  }
}
StoryEvent_CardBoostInfo_BoostItem_AffinityItem.Builder = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Builder;
class StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent {
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_AffinityItem} value
   * @param {StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemAffinity() {
    if (this._cachedHasItemAffinity === undefined) {
      if (this._value.hasItemAffinity) {
        this._cachedHasItemAffinity = true;
      } else {
        this._cachedHasItemAffinity = this._parent ? this._parent.hasItemAffinity : false;
      }
    }
    return this._cachedHasItemAffinity;
  }
  get itemAffinity() {
    if (this._cachedItemAffinity === undefined) {
      if (this._value.hasItemAffinity) {
        this._cachedItemAffinity = this._value.itemAffinity;
      } else {
        this._cachedItemAffinity = this._parent ? this._parent.itemAffinity : this._value.itemAffinity;
      }
    }
    return this._cachedItemAffinity;
  }
  update(current, parent) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent(current, parent);
    return result;
  }
}
StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent.default = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent(StoryEvent_CardBoostInfo_BoostItem_AffinityItem.default, null);
StoryEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent = StoryEvent_CardBoostInfo_BoostItem_AffinityItem_WithParent;
class StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Descriptor {
  get itemAffinity() {
    if (!this._itemAffinity) {
      this._itemAffinity = {
        name: "itemAffinity",
        Name: "ItemAffinity",
        number: 1,
        protoType: 14,
        protoName: "item_affinity",
        type: StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Affinity,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemAffinity;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemAffinity,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemAffinity",
        Name: "DummyOneofForItemAffinity",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_CardBoostInfo_BoostItem_AffinityItem.descriptor = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem_Descriptor();
class StoryEvent_CardBoostInfo_BoostItem_BoostInfo {
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBoostType = false;
    this._boostType = null;
    this._hasBoostNumber = false;
    this._boostNumber = null;
  }
  isEmpty() {
    if (this._hasBoostType) return false;
    if (this._hasBoostNumber) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CardBoostInfo_BoostItem_BoostInfo) {
      return value;
    }
    return StoryEvent_CardBoostInfo_BoostItem_BoostInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo();
    if (json.boostType != null) {
      result._hasBoostType = true;
      result._boostType = StoryEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(json.boostType);
    }
    if (json.boostNumber != null) {
      result._hasBoostNumber = true;
      result._boostNumber = JsonToInt32.fromJson(json.boostNumber);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBoostType) {
      result.boostType = StoryEvent_CardBoostInfo_BoostItem_BoostProperty.toJson(this._boostType);
    }
    if (this._hasBoostNumber) {
      result.boostNumber = JsonToInt32.toJson(this._boostNumber);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get boostType() {
    return this._hasBoostType ? this._boostType : StoryEvent_CardBoostInfo_BoostItem_BoostProperty.default;
  }
  get hasBoostType() {
    return this._hasBoostType;
  }
  setBoostType(path, value) {
    return {type: 'SET', path: path.concat(['boostType']), value};
  }
  deleteBoostType(path) {
    return {type: 'DELETE', path: path.concat(['boostType'])};
  }
  /**
   * @returns {number}
   */
  get boostNumber() {
    return this._hasBoostNumber ? this._boostNumber : JsonToInt32.default;
  }
  get hasBoostNumber() {
    return this._hasBoostNumber;
  }
  setBoostNumber(path, value) {
    return {type: 'SET', path: path.concat(['boostNumber']), value};
  }
  deleteBoostNumber(path) {
    return {type: 'DELETE', path: path.concat(['boostNumber'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boostType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostType = true;
              copy._boostType = StoryEvent_CardBoostInfo_BoostItem_BoostProperty.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBoostType) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostType = false;
              copy._boostType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "boostNumber": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostNumber = true;
              copy._boostNumber = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBoostNumber) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this);
              copy._hasBoostNumber = false;
              copy._boostNumber = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_BoostInfo} other
   * @returns {StoryEvent_CardBoostInfo_BoostItem_BoostInfo}
   */
  merge(other) {
    const copy = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this);
    if (other._hasBoostType) {
      copy._hasBoostType = true;
      copy._boostType = other._boostType;
    }
    if (other._hasBoostNumber) {
      copy._hasBoostNumber = true;
      copy._boostNumber = other._boostNumber;
    }
    return copy;
  }
}
StoryEvent_CardBoostInfo_BoostItem_BoostInfo.default = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo();
class StoryEvent_CardBoostInfo_BoostItem_BoostInfo_Builder {
  constructor(value) {
    this._value = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(value);
  }
  build() {
    return new StoryEvent_CardBoostInfo_BoostItem_BoostInfo(this._value);
  }
  setBoostType(value) {
    this._value._hasBoostType = true;
    this._value._boostType = value;
    return this;
  }
  deleteBoostType() {
    this._value._hasBoostType = false;
    this._value._boostType = null;
    return this;
  }
  setBoostNumber(value) {
    this._value._hasBoostNumber = true;
    this._value._boostNumber = value;
    return this;
  }
  deleteBoostNumber() {
    this._value._hasBoostNumber = false;
    this._value._boostNumber = null;
    return this;
  }
}
StoryEvent_CardBoostInfo_BoostItem_BoostInfo.Builder = StoryEvent_CardBoostInfo_BoostItem_BoostInfo_Builder;
class StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent {
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem_BoostInfo} value
   * @param {StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBoostType() {
    if (this._cachedHasBoostType === undefined) {
      if (this._value.hasBoostType) {
        this._cachedHasBoostType = true;
      } else {
        this._cachedHasBoostType = this._parent ? this._parent.hasBoostType : false;
      }
    }
    return this._cachedHasBoostType;
  }
  get boostType() {
    if (this._cachedBoostType === undefined) {
      if (this._value.hasBoostType) {
        this._cachedBoostType = this._value.boostType;
      } else {
        this._cachedBoostType = this._parent ? this._parent.boostType : this._value.boostType;
      }
    }
    return this._cachedBoostType;
  }
  get hasBoostNumber() {
    if (this._cachedHasBoostNumber === undefined) {
      if (this._value.hasBoostNumber) {
        this._cachedHasBoostNumber = true;
      } else {
        this._cachedHasBoostNumber = this._parent ? this._parent.hasBoostNumber : false;
      }
    }
    return this._cachedHasBoostNumber;
  }
  get boostNumber() {
    if (this._cachedBoostNumber === undefined) {
      if (this._value.hasBoostNumber) {
        this._cachedBoostNumber = this._value.boostNumber;
      } else {
        this._cachedBoostNumber = this._parent ? this._parent.boostNumber : this._value.boostNumber;
      }
    }
    return this._cachedBoostNumber;
  }
  update(current, parent) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent(current, parent);
    return result;
  }
}
StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent.default = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent(StoryEvent_CardBoostInfo_BoostItem_BoostInfo.default, null);
StoryEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent = StoryEvent_CardBoostInfo_BoostItem_BoostInfo_WithParent;
class StoryEvent_CardBoostInfo_BoostItem_BoostInfo_Descriptor {
  get boostType() {
    if (!this._boostType) {
      this._boostType = {
        name: "boostType",
        Name: "BoostType",
        number: 1,
        protoType: 14,
        protoName: "boost_type",
        type: StoryEvent_CardBoostInfo_BoostItem_BoostProperty,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostType;
  }
  get boostNumber() {
    if (!this._boostNumber) {
      this._boostNumber = {
        name: "boostNumber",
        Name: "BoostNumber",
        number: 2,
        protoType: 5,
        protoName: "boost_number",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostNumber;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boostType,
        this.boostNumber,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBoostType",
        Name: "DummyOneofForBoostType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBoostNumber",
        Name: "DummyOneofForBoostNumber",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_CardBoostInfo_BoostItem_BoostInfo.descriptor = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo_Descriptor();
class StoryEvent_CardBoostInfo_BoostItem_BoostProperty {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LEVEL": return 0;
        case "SKILL": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return StoryEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(value);
  }
  static fromReact(e) {
    return StoryEvent_CardBoostInfo_BoostItem_BoostProperty.fromJson(e);
  }
}
StoryEvent_CardBoostInfo_BoostItem_BoostProperty.LEVEL = 0;
StoryEvent_CardBoostInfo_BoostItem_BoostProperty.SKILL = 1;
StoryEvent_CardBoostInfo_BoostItem_BoostProperty.default = 0;
StoryEvent_CardBoostInfo_BoostItem_BoostProperty.values = {
  LEVEL: 0,
  SKILL: 1,
};
StoryEvent_CardBoostInfo_BoostItem_BoostProperty.names = {
  0: "LEVEL",
  1: "SKILL",
};
class StoryEvent_CardBoostInfo_BoostItem {
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
    this._boostInfoList = [];
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    if (this._boostInfoList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CardBoostInfo_BoostItem) {
      return value;
    }
    return StoryEvent_CardBoostInfo_BoostItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CardBoostInfo_BoostItem();
    if (json.cardItem != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_CardItem.fromJson(json.cardItem);
    }
    if (json.affinityItem != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_AffinityItem.fromJson(json.affinityItem);
    }
    result._boostInfoList = JsonToList(json.boostInfoList, StoryEvent_CardBoostInfo_BoostItem_BoostInfo);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.cardItem = StoryEvent_CardBoostInfo_BoostItem_CardItem.toJson(this._itemTypeValue);
        break;
      case 2:
        result.affinityItem = StoryEvent_CardBoostInfo_BoostItem_AffinityItem.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    if (this._boostInfoList.length > 0) {
      result.boostInfoList = ArrayToJson(this._boostInfoList, StoryEvent_CardBoostInfo_BoostItem_BoostInfo);
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['cardItem'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['affinityItem'])};
      }
    }
  }
  /**
   * @returns {StoryEvent_CardBoostInfo_BoostItem_CardItem}
   */
  get cardItem() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : StoryEvent_CardBoostInfo_BoostItem_CardItem.default;
  }
  setCardItem(path, value) {
    return {type: 'SET', path: path.concat(['cardItem']), value: value.toJson()};
  }
  deleteCardItem(path) {
    return {type: 'DELETE', path: path.concat(['cardItem'])};
  }
  /**
   * @returns {StoryEvent_CardBoostInfo_BoostItem_AffinityItem}
   */
  get affinityItem() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : StoryEvent_CardBoostInfo_BoostItem_AffinityItem.default;
  }
  setAffinityItem(path, value) {
    return {type: 'SET', path: path.concat(['affinityItem']), value: value.toJson()};
  }
  deleteAffinityItem(path) {
    return {type: 'DELETE', path: path.concat(['affinityItem'])};
  }
  /**
   * @returns {StoryEvent_CardBoostInfo_BoostItem_BoostInfo[]}
   */
  get boostInfoList() {
    return this._boostInfoList;
  }
  addBoostInfoList(path, value) {
    return {type: 'ADD', path: path.concat(['boostInfoList']), value: value.toJson()};
  }
  setBoostInfoList(path, value) {
    return {type: 'SET', path: path.concat(['boostInfoList']), value: ArrayToJson(value, StoryEvent_CardBoostInfo_BoostItem_BoostInfo)};
  }
  setBoostInfoListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['boostInfoList', key]), value: value.toJson()};
  }
  deleteBoostInfoList(path) {
    return {type: 'DELETE', path: path.concat(['boostInfoList'])};
  }
  deleteBoostInfoListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['boostInfoList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_CardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._itemTypeCase !== 1) {
            const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
            copy._itemTypeCase = 1;
            copy._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_CardItem.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.cardItem.apply(type, path.slice(1), value);
          if (newValue === this.cardItem) {
            return this;
          }
          const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
          copy._itemTypeCase = 1;
          copy._itemTypeValue = newValue;
          return copy;
        }
      }
      case "affinityItem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_AffinityItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._itemTypeCase !== 2) {
            const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
            copy._itemTypeCase = 2;
            copy._itemTypeValue = StoryEvent_CardBoostInfo_BoostItem_AffinityItem.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.affinityItem.apply(type, path.slice(1), value);
          if (newValue === this.affinityItem) {
            return this;
          }
          const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
          copy._itemTypeCase = 2;
          copy._itemTypeValue = newValue;
          return copy;
        }
      }
      case "boostInfoList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = [];        for (let i of value) {
                copy._boostInfoList.push(StoryEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.concat([StoryEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._boostInfoList.length === 0) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._boostInfoList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.slice();
              copy._boostInfoList[path[1]] = StoryEvent_CardBoostInfo_BoostItem_BoostInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
              copy._boostInfoList = copy._boostInfoList.slice(0, path[1]).concat(copy._boostInfoList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._boostInfoList.length) {
            return this;
          }
          const oldValue = this._boostInfoList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
          copy._boostInfoList = copy._boostInfoList.slice();
          copy._boostInfoList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem} other
   * @returns {StoryEvent_CardBoostInfo_BoostItem}
   */
  merge(other) {
    const copy = new StoryEvent_CardBoostInfo_BoostItem(this);
    if (other._itemTypeCase === 1) {
      if (this._itemTypeCase === 1) {
        copy._itemTypeValue = copy._itemTypeValue.merge(other._itemTypeValue);
      } else {
        copy._itemTypeValue = other._itemTypeValue;
      }
      copy._itemTypeCase = 1;
    }
    if (other._itemTypeCase === 1) {
      if (this._itemTypeCase === 1) {
        copy._itemTypeValue = copy._itemTypeValue.merge(other._itemTypeValue);
      } else {
        copy._itemTypeValue = other._itemTypeValue;
      }
      copy._itemTypeCase = 1;
    }
    copy._boostInfoList = this._boostInfoList.concat(other._boostInfoList);
    return copy;
  }
}
StoryEvent_CardBoostInfo_BoostItem.default = new StoryEvent_CardBoostInfo_BoostItem();
StoryEvent_CardBoostInfo_BoostItem.CardItem = StoryEvent_CardBoostInfo_BoostItem_CardItem;
StoryEvent_CardBoostInfo_BoostItem.AffinityItem = StoryEvent_CardBoostInfo_BoostItem_AffinityItem;
StoryEvent_CardBoostInfo_BoostItem.BoostInfo = StoryEvent_CardBoostInfo_BoostItem_BoostInfo;
StoryEvent_CardBoostInfo_BoostItem.BoostProperty = StoryEvent_CardBoostInfo_BoostItem_BoostProperty;
class StoryEvent_CardBoostInfo_BoostItem_Builder {
  constructor(value) {
    this._value = new StoryEvent_CardBoostInfo_BoostItem(value);
  }
  build() {
    return new StoryEvent_CardBoostInfo_BoostItem(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setCardItem(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setAffinityItem(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
  addAllBoostInfoList(values) {
    this._value._boostInfoList = this._value._boostInfoList.concat(values);
    return this;
  }
  addBoostInfoList(value) {
    this._value._boostInfoList = this._value._boostInfoList.concat([value]);
    return this;
  }
  setBoostInfoList(index, value) {
    this._value._boostInfoList = this._value._boostInfoList.concat();
    this._value._boostInfoList[index] = value;
    return this;
  }
  clearBoostInfoList() {
    this._value._boostInfoList = [];
    return this;
  }
}
StoryEvent_CardBoostInfo_BoostItem.Builder = StoryEvent_CardBoostInfo_BoostItem_Builder;
class StoryEvent_CardBoostInfo_BoostItem_WithParent {
  /**
   * @param {StoryEvent_CardBoostInfo_BoostItem} value
   * @param {StoryEvent_CardBoostInfo_BoostItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CardBoostInfo_BoostItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get cardItem() {
    if (!this._cachedCardItem) {
      if (this._value._itemTypeCase === 0) {
        this._cachedCardItem = this._parent ? new StoryEvent_CardBoostInfo_BoostItem_CardItem.WithParent(StoryEvent_CardBoostInfo_BoostItem_CardItem.default, this._parent.cardItem) : this._value.cardItem;
      } else if (this._value._itemTypeCase === 1) {
        this._cachedCardItem = new StoryEvent_CardBoostInfo_BoostItem_CardItem.WithParent(this._value.cardItem, this._parent && this._parent.itemTypeCase === 1 ? this._parent.cardItem : null);
      } else {
        this._cachedCardItem = StoryEvent_CardBoostInfo_BoostItem_CardItem.WithParent.default;
      }
    }
    return this._cachedCardItem;
  }
  get affinityItem() {
    if (!this._cachedAffinityItem) {
      if (this._value._itemTypeCase === 0) {
        this._cachedAffinityItem = this._parent ? new StoryEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent(StoryEvent_CardBoostInfo_BoostItem_AffinityItem.default, this._parent.affinityItem) : this._value.affinityItem;
      } else if (this._value._itemTypeCase === 2) {
        this._cachedAffinityItem = new StoryEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent(this._value.affinityItem, this._parent && this._parent.itemTypeCase === 2 ? this._parent.affinityItem : null);
      } else {
        this._cachedAffinityItem = StoryEvent_CardBoostInfo_BoostItem_AffinityItem.WithParent.default;
      }
    }
    return this._cachedAffinityItem;
  }
  get selfBoostInfoList() {
    if (!this._selfBoostInfoList) {
      this._selfBoostInfoList = [];
      for (let i of this._value.boostInfoList) {
        this._selfBoostInfoList.push(new StoryEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent(i, null));
      }
    }
    return this._selfBoostInfoList;
  }
  get inherentBoostInfoList() {
    if (!this._inherentBoostInfoList) {
      this._inherentBoostInfoList = this._parent ? this._parent.boostInfoList : [];
    }
    return this._inherentBoostInfoList;
  }
  get boostInfoList() {
    if (!this._allBoostInfoList) {
      this._allBoostInfoList = this._parent ? this._parent.boostInfoList.concat(this.selfBoostInfoList) : this.selfBoostInfoList;
    }
    return this._allBoostInfoList;
  }
  update(current, parent) {
    const result = new StoryEvent_CardBoostInfo_BoostItem_WithParent(current, parent);
    if (this._cachedCardItem && this._value._itemTypeCase === 1 && current._itemTypeCase === 1) {
      if (this._value.cardItem === current.cardItem && this._parent === parent) {
        result._cachedCardItem = this._cachedCardItem;
      } else {
        result._cachedCardItem = this._cachedCardItem.update(current.cardItem, parent && parent.itemTypeCase === 1 ? parent.cardItem : null);
      }
    }
    if (this._cachedAffinityItem && this._value._itemTypeCase === 2 && current._itemTypeCase === 2) {
      if (this._value.affinityItem === current.affinityItem && this._parent === parent) {
        result._cachedAffinityItem = this._cachedAffinityItem;
      } else {
        result._cachedAffinityItem = this._cachedAffinityItem.update(current.affinityItem, parent && parent.itemTypeCase === 2 ? parent.affinityItem : null);
      }
    }
    if (this._selfBoostInfoList) {
      if (this._value.boostInfoList === current.boostInfoList) {
        result._selfBoostInfoList = this._selfBoostInfoList;
      } else {
        result._selfBoostInfoList = [];
        for (let i = 0; i < current.boostInfoList.length; i++) {
          const oldValue = this._value.boostInfoList[i];
          if (oldValue) {
            const oldCache = this._selfBoostInfoList[i];
            if (oldValue === current.boostInfoList[i]) {
              result._selfBoostInfoList[i] = oldCache;
            } else {
              result._selfBoostInfoList[i] = oldCache.update(current.boostInfoList[i], null);
            }
          } else {
            result._selfBoostInfoList[i] = new StoryEvent_CardBoostInfo_BoostItem_BoostInfo.WithParent(current.boostInfoList[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEvent_CardBoostInfo_BoostItem_WithParent.default = new StoryEvent_CardBoostInfo_BoostItem_WithParent(StoryEvent_CardBoostInfo_BoostItem.default, null);
StoryEvent_CardBoostInfo_BoostItem.WithParent = StoryEvent_CardBoostInfo_BoostItem_WithParent;
class StoryEvent_CardBoostInfo_BoostItem_Descriptor {
  get cardItem() {
    if (!this._cardItem) {
      this._cardItem = {
        name: "cardItem",
        Name: "CardItem",
        number: 1,
        protoType: 11,
        protoName: "card_item",
        oneofIndex: 0,
        type: StoryEvent_CardBoostInfo_BoostItem_CardItem,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardItem;
  }
  get affinityItem() {
    if (!this._affinityItem) {
      this._affinityItem = {
        name: "affinityItem",
        Name: "AffinityItem",
        number: 2,
        protoType: 11,
        protoName: "affinity_item",
        oneofIndex: 0,
        type: StoryEvent_CardBoostInfo_BoostItem_AffinityItem,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityItem;
  }
  get boostInfoList() {
    if (!this._boostInfoList) {
      this._boostInfoList = {
        name: "boostInfoList",
        Name: "BoostInfoList",
        number: 3,
        protoType: 11,
        protoName: "boost_info_list",
        type: StoryEvent_CardBoostInfo_BoostItem_BoostInfo,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostInfoList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardItem,
        this.affinityItem,
        this.boostInfoList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_CardBoostInfo_BoostItem.descriptor = new StoryEvent_CardBoostInfo_BoostItem_Descriptor();
class StoryEvent_CardBoostInfo {
  get descriptor() {
    return StoryEvent_CardBoostInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._boostItems = [];
  }
  isEmpty() {
    if (this._boostItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CardBoostInfo) {
      return value;
    }
    return StoryEvent_CardBoostInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CardBoostInfo();
    result._boostItems = JsonToList(json.boostItems, StoryEvent_CardBoostInfo_BoostItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._boostItems.length > 0) {
      result.boostItems = ArrayToJson(this._boostItems, StoryEvent_CardBoostInfo_BoostItem);
    }
    return result;
  }
  /**
   * @returns {StoryEvent_CardBoostInfo_BoostItem[]}
   */
  get boostItems() {
    return this._boostItems;
  }
  addBoostItems(path, value) {
    return {type: 'ADD', path: path.concat(['boostItems']), value: value.toJson()};
  }
  setBoostItems(path, value) {
    return {type: 'SET', path: path.concat(['boostItems']), value: ArrayToJson(value, StoryEvent_CardBoostInfo_BoostItem)};
  }
  setBoostItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['boostItems', key]), value: value.toJson()};
  }
  deleteBoostItems(path) {
    return {type: 'DELETE', path: path.concat(['boostItems'])};
  }
  deleteBoostItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['boostItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boostItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo(this);
              copy._boostItems = [];        for (let i of value) {
                copy._boostItems.push(StoryEvent_CardBoostInfo_BoostItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.concat([StoryEvent_CardBoostInfo_BoostItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._boostItems.length === 0) {
                return this;
              }
              const copy = new StoryEvent_CardBoostInfo(this);
              copy._boostItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._boostItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.slice();
              copy._boostItems[path[1]] = StoryEvent_CardBoostInfo_BoostItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEvent_CardBoostInfo(this);
              copy._boostItems = copy._boostItems.slice(0, path[1]).concat(copy._boostItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._boostItems.length) {
            return this;
          }
          const oldValue = this._boostItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEvent_CardBoostInfo(this);
          copy._boostItems = copy._boostItems.slice();
          copy._boostItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CardBoostInfo} other
   * @returns {StoryEvent_CardBoostInfo}
   */
  merge(other) {
    const copy = new StoryEvent_CardBoostInfo(this);
    copy._boostItems = this._boostItems.concat(other._boostItems);
    return copy;
  }
}
StoryEvent_CardBoostInfo.default = new StoryEvent_CardBoostInfo();
StoryEvent_CardBoostInfo.BoostItem = StoryEvent_CardBoostInfo_BoostItem;
class StoryEvent_CardBoostInfo_Builder {
  constructor(value) {
    this._value = new StoryEvent_CardBoostInfo(value);
  }
  build() {
    return new StoryEvent_CardBoostInfo(this._value);
  }
  addAllBoostItems(values) {
    this._value._boostItems = this._value._boostItems.concat(values);
    return this;
  }
  addBoostItems(value) {
    this._value._boostItems = this._value._boostItems.concat([value]);
    return this;
  }
  setBoostItems(index, value) {
    this._value._boostItems = this._value._boostItems.concat();
    this._value._boostItems[index] = value;
    return this;
  }
  clearBoostItems() {
    this._value._boostItems = [];
    return this;
  }
}
StoryEvent_CardBoostInfo.Builder = StoryEvent_CardBoostInfo_Builder;
class StoryEvent_CardBoostInfo_WithParent {
  /**
   * @param {StoryEvent_CardBoostInfo} value
   * @param {StoryEvent_CardBoostInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CardBoostInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfBoostItems() {
    if (!this._selfBoostItems) {
      this._selfBoostItems = [];
      for (let i of this._value.boostItems) {
        this._selfBoostItems.push(new StoryEvent_CardBoostInfo_BoostItem.WithParent(i, null));
      }
    }
    return this._selfBoostItems;
  }
  get inherentBoostItems() {
    if (!this._inherentBoostItems) {
      this._inherentBoostItems = this._parent ? this._parent.boostItems : [];
    }
    return this._inherentBoostItems;
  }
  get boostItems() {
    if (!this._allBoostItems) {
      this._allBoostItems = this._parent ? this._parent.boostItems.concat(this.selfBoostItems) : this.selfBoostItems;
    }
    return this._allBoostItems;
  }
  update(current, parent) {
    const result = new StoryEvent_CardBoostInfo_WithParent(current, parent);
    if (this._selfBoostItems) {
      if (this._value.boostItems === current.boostItems) {
        result._selfBoostItems = this._selfBoostItems;
      } else {
        result._selfBoostItems = [];
        for (let i = 0; i < current.boostItems.length; i++) {
          const oldValue = this._value.boostItems[i];
          if (oldValue) {
            const oldCache = this._selfBoostItems[i];
            if (oldValue === current.boostItems[i]) {
              result._selfBoostItems[i] = oldCache;
            } else {
              result._selfBoostItems[i] = oldCache.update(current.boostItems[i], null);
            }
          } else {
            result._selfBoostItems[i] = new StoryEvent_CardBoostInfo_BoostItem.WithParent(current.boostItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEvent_CardBoostInfo_WithParent.default = new StoryEvent_CardBoostInfo_WithParent(StoryEvent_CardBoostInfo.default, null);
StoryEvent_CardBoostInfo.WithParent = StoryEvent_CardBoostInfo_WithParent;
class StoryEvent_CardBoostInfo_Descriptor {
  get boostItems() {
    if (!this._boostItems) {
      this._boostItems = {
        name: "boostItems",
        Name: "BoostItems",
        number: 1,
        protoType: 11,
        protoName: "boost_items",
        type: StoryEvent_CardBoostInfo_BoostItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boostItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boostItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
StoryEvent_CardBoostInfo.descriptor = new StoryEvent_CardBoostInfo_Descriptor();
class StoryEvent_PlayerLevelTrigger {
  get descriptor() {
    return StoryEvent_PlayerLevelTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
  }
  isEmpty() {
    if (this._hasPlayerLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_PlayerLevelTrigger) {
      return value;
    }
    return StoryEvent_PlayerLevelTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_PlayerLevelTrigger();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = JsonToInt32.fromJson(json.playerLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel) {
      result.playerLevel = JsonToInt32.toJson(this._playerLevel);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : JsonToInt32.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_PlayerLevelTrigger(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new StoryEvent_PlayerLevelTrigger(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_PlayerLevelTrigger} other
   * @returns {StoryEvent_PlayerLevelTrigger}
   */
  merge(other) {
    const copy = new StoryEvent_PlayerLevelTrigger(this);
    if (other._hasPlayerLevel) {
      copy._hasPlayerLevel = true;
      copy._playerLevel = other._playerLevel;
    }
    return copy;
  }
}
StoryEvent_PlayerLevelTrigger.default = new StoryEvent_PlayerLevelTrigger();
class StoryEvent_PlayerLevelTrigger_Builder {
  constructor(value) {
    this._value = new StoryEvent_PlayerLevelTrigger(value);
  }
  build() {
    return new StoryEvent_PlayerLevelTrigger(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
}
StoryEvent_PlayerLevelTrigger.Builder = StoryEvent_PlayerLevelTrigger_Builder;
class StoryEvent_PlayerLevelTrigger_WithParent {
  /**
   * @param {StoryEvent_PlayerLevelTrigger} value
   * @param {StoryEvent_PlayerLevelTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_PlayerLevelTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (this._cachedPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = this._value.playerLevel;
      } else {
        this._cachedPlayerLevel = this._parent ? this._parent.playerLevel : this._value.playerLevel;
      }
    }
    return this._cachedPlayerLevel;
  }
  update(current, parent) {
    const result = new StoryEvent_PlayerLevelTrigger_WithParent(current, parent);
    return result;
  }
}
StoryEvent_PlayerLevelTrigger_WithParent.default = new StoryEvent_PlayerLevelTrigger_WithParent(StoryEvent_PlayerLevelTrigger.default, null);
StoryEvent_PlayerLevelTrigger.WithParent = StoryEvent_PlayerLevelTrigger_WithParent;
class StoryEvent_PlayerLevelTrigger_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 5,
        protoName: "player_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_PlayerLevelTrigger.descriptor = new StoryEvent_PlayerLevelTrigger_Descriptor();
class StoryEvent_CampaignLevelTrigger {
  get descriptor() {
    return StoryEvent_CampaignLevelTrigger.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWorldIndex = false;
    this._worldIndex = null;
    this._hasLevelIndex = false;
    this._levelIndex = null;
  }
  isEmpty() {
    if (this._hasWorldIndex) return false;
    if (this._hasLevelIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent_CampaignLevelTrigger) {
      return value;
    }
    return StoryEvent_CampaignLevelTrigger.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent_CampaignLevelTrigger();
    if (json.worldIndex != null) {
      result._hasWorldIndex = true;
      result._worldIndex = JsonToInt32.fromJson(json.worldIndex);
    }
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWorldIndex) {
      result.worldIndex = JsonToInt32.toJson(this._worldIndex);
    }
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get worldIndex() {
    return this._hasWorldIndex ? this._worldIndex : JsonToInt32.default;
  }
  get hasWorldIndex() {
    return this._hasWorldIndex;
  }
  setWorldIndex(path, value) {
    return {type: 'SET', path: path.concat(['worldIndex']), value};
  }
  deleteWorldIndex(path) {
    return {type: 'DELETE', path: path.concat(['worldIndex'])};
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "worldIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CampaignLevelTrigger(this);
              copy._hasWorldIndex = true;
              copy._worldIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWorldIndex) {
                return this;
              }
              const copy = new StoryEvent_CampaignLevelTrigger(this);
              copy._hasWorldIndex = false;
              copy._worldIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent_CampaignLevelTrigger(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new StoryEvent_CampaignLevelTrigger(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent_CampaignLevelTrigger} other
   * @returns {StoryEvent_CampaignLevelTrigger}
   */
  merge(other) {
    const copy = new StoryEvent_CampaignLevelTrigger(this);
    if (other._hasWorldIndex) {
      copy._hasWorldIndex = true;
      copy._worldIndex = other._worldIndex;
    }
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    return copy;
  }
}
StoryEvent_CampaignLevelTrigger.default = new StoryEvent_CampaignLevelTrigger();
class StoryEvent_CampaignLevelTrigger_Builder {
  constructor(value) {
    this._value = new StoryEvent_CampaignLevelTrigger(value);
  }
  build() {
    return new StoryEvent_CampaignLevelTrigger(this._value);
  }
  setWorldIndex(value) {
    this._value._hasWorldIndex = true;
    this._value._worldIndex = value;
    return this;
  }
  deleteWorldIndex() {
    this._value._hasWorldIndex = false;
    this._value._worldIndex = null;
    return this;
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
}
StoryEvent_CampaignLevelTrigger.Builder = StoryEvent_CampaignLevelTrigger_Builder;
class StoryEvent_CampaignLevelTrigger_WithParent {
  /**
   * @param {StoryEvent_CampaignLevelTrigger} value
   * @param {StoryEvent_CampaignLevelTrigger_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent_CampaignLevelTrigger.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWorldIndex() {
    if (this._cachedHasWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedHasWorldIndex = true;
      } else {
        this._cachedHasWorldIndex = this._parent ? this._parent.hasWorldIndex : false;
      }
    }
    return this._cachedHasWorldIndex;
  }
  get worldIndex() {
    if (this._cachedWorldIndex === undefined) {
      if (this._value.hasWorldIndex) {
        this._cachedWorldIndex = this._value.worldIndex;
      } else {
        this._cachedWorldIndex = this._parent ? this._parent.worldIndex : this._value.worldIndex;
      }
    }
    return this._cachedWorldIndex;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  update(current, parent) {
    const result = new StoryEvent_CampaignLevelTrigger_WithParent(current, parent);
    return result;
  }
}
StoryEvent_CampaignLevelTrigger_WithParent.default = new StoryEvent_CampaignLevelTrigger_WithParent(StoryEvent_CampaignLevelTrigger.default, null);
StoryEvent_CampaignLevelTrigger.WithParent = StoryEvent_CampaignLevelTrigger_WithParent;
class StoryEvent_CampaignLevelTrigger_Descriptor {
  get worldIndex() {
    if (!this._worldIndex) {
      this._worldIndex = {
        name: "worldIndex",
        Name: "WorldIndex",
        number: 1,
        protoType: 5,
        protoName: "world_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._worldIndex;
  }
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 2,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.worldIndex,
        this.levelIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWorldIndex",
        Name: "DummyOneofForWorldIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent_CampaignLevelTrigger.descriptor = new StoryEvent_CampaignLevelTrigger_Descriptor();
export class StoryEvent {
  get descriptor() {
    return StoryEvent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasEventName = false;
    this._eventName = null;
    this._hasEventLevel = false;
    this._eventLevel = null;
    this._hasStoryPanel = false;
    this._storyPanel = null;
    this._triggerTypeCase = 0;
    this._triggerTypeValue = null;
    this._hasCardBoostInfo = false;
    this._cardBoostInfo = null;
    this._hasFeaturedCard = false;
    this._featuredCard = null;
    this._hasFeaturedSkin = false;
    this._featuredSkin = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasEventName) return false;
    if (this._hasEventLevel && !this._eventLevel.isEmpty()) return false;
    if (this._hasStoryPanel) return false;
    if (this._triggerTypeCase !== 0) return false;
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) return false;
    if (this._hasFeaturedCard) return false;
    if (this._hasFeaturedSkin && !this._featuredSkin.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEvent) {
      return value;
    }
    return StoryEvent.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEvent();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.eventName != null) {
      result._hasEventName = true;
      result._eventName = JsonToString.fromJson(json.eventName);
    }
    if (json.eventLevel != null) {
      result._hasEventLevel = true;
      result._eventLevel = StoryEvent_EventLevel.fromJson(json.eventLevel);
    }
    if (json.storyPanel != null) {
      result._hasStoryPanel = true;
      result._storyPanel = JsonToString.fromJson(json.storyPanel);
    }
    if (json.playerLevelTrigger != null) {
      result._triggerTypeCase = 31;
      result._triggerTypeValue = StoryEvent_PlayerLevelTrigger.fromJson(json.playerLevelTrigger);
    }
    if (json.campaignLevelTrigger != null) {
      result._triggerTypeCase = 32;
      result._triggerTypeValue = StoryEvent_CampaignLevelTrigger.fromJson(json.campaignLevelTrigger);
    }
    if (json.cardBoostInfo != null) {
      result._hasCardBoostInfo = true;
      result._cardBoostInfo = StoryEvent_CardBoostInfo.fromJson(json.cardBoostInfo);
    }
    if (json.featuredCard != null) {
      result._hasFeaturedCard = true;
      result._featuredCard = JsonToString.fromJson(json.featuredCard);
    }
    if (json.featuredSkin != null) {
      result._hasFeaturedSkin = true;
      result._featuredSkin = dcei_wildsky_card_proto.CardSkin.fromJson(json.featuredSkin);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasEventName) {
      result.eventName = JsonToString.toJson(this._eventName);
    }
    if (this._hasEventLevel && !this._eventLevel.isEmpty()) {
      result.eventLevel = StoryEvent_EventLevel.toJson(this._eventLevel);
    }
    if (this._hasStoryPanel) {
      result.storyPanel = JsonToString.toJson(this._storyPanel);
    }
    switch (this._triggerTypeCase) {
      case 31:
        result.playerLevelTrigger = StoryEvent_PlayerLevelTrigger.toJson(this._triggerTypeValue);
        break;
      case 32:
        result.campaignLevelTrigger = StoryEvent_CampaignLevelTrigger.toJson(this._triggerTypeValue);
        break;
      default:
        break;
    }
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) {
      result.cardBoostInfo = StoryEvent_CardBoostInfo.toJson(this._cardBoostInfo);
    }
    if (this._hasFeaturedCard) {
      result.featuredCard = JsonToString.toJson(this._featuredCard);
    }
    if (this._hasFeaturedSkin && !this._featuredSkin.isEmpty()) {
      result.featuredSkin = dcei_wildsky_card_proto.CardSkin.toJson(this._featuredSkin);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get eventName() {
    return this._hasEventName ? this._eventName : JsonToString.default;
  }
  get hasEventName() {
    return this._hasEventName;
  }
  setEventName(path, value) {
    return {type: 'SET', path: path.concat(['eventName']), value};
  }
  deleteEventName(path) {
    return {type: 'DELETE', path: path.concat(['eventName'])};
  }
  /**
   * @returns {StoryEvent_EventLevel}
   */
  get eventLevel() {
    return this._hasEventLevel ? this._eventLevel : StoryEvent_EventLevel.default;
  }
  get hasEventLevel() {
    return this._hasEventLevel;
  }
  setEventLevel(path, value) {
    return {type: 'SET', path: path.concat(['eventLevel']), value: value.toJson()};
  }
  deleteEventLevel(path) {
    return {type: 'DELETE', path: path.concat(['eventLevel'])};
  }
  /**
   * @returns {string}
   */
  get storyPanel() {
    return this._hasStoryPanel ? this._storyPanel : JsonToString.default;
  }
  get hasStoryPanel() {
    return this._hasStoryPanel;
  }
  setStoryPanel(path, value) {
    return {type: 'SET', path: path.concat(['storyPanel']), value};
  }
  deleteStoryPanel(path) {
    return {type: 'DELETE', path: path.concat(['storyPanel'])};
  }
  get triggerTypeCase() {
    return this._triggerTypeCase;
  }
  deleteTriggerType(path) {
    switch (this._triggerTypeCase) {
      default:
      case 31: {
        return {type: 'DELETE', path: path.concat(['playerLevelTrigger'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['campaignLevelTrigger'])};
      }
    }
  }
  /**
   * @returns {StoryEvent_PlayerLevelTrigger}
   */
  get playerLevelTrigger() {
    return this._triggerTypeCase === 31 ? this._triggerTypeValue : StoryEvent_PlayerLevelTrigger.default;
  }
  setPlayerLevelTrigger(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelTrigger']), value: value.toJson()};
  }
  deletePlayerLevelTrigger(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelTrigger'])};
  }
  /**
   * @returns {StoryEvent_CampaignLevelTrigger}
   */
  get campaignLevelTrigger() {
    return this._triggerTypeCase === 32 ? this._triggerTypeValue : StoryEvent_CampaignLevelTrigger.default;
  }
  setCampaignLevelTrigger(path, value) {
    return {type: 'SET', path: path.concat(['campaignLevelTrigger']), value: value.toJson()};
  }
  deleteCampaignLevelTrigger(path) {
    return {type: 'DELETE', path: path.concat(['campaignLevelTrigger'])};
  }
  /**
   * @returns {StoryEvent_CardBoostInfo}
   */
  get cardBoostInfo() {
    return this._hasCardBoostInfo ? this._cardBoostInfo : StoryEvent_CardBoostInfo.default;
  }
  get hasCardBoostInfo() {
    return this._hasCardBoostInfo;
  }
  setCardBoostInfo(path, value) {
    return {type: 'SET', path: path.concat(['cardBoostInfo']), value: value.toJson()};
  }
  deleteCardBoostInfo(path) {
    return {type: 'DELETE', path: path.concat(['cardBoostInfo'])};
  }
  /**
   * @returns {string}
   */
  get featuredCard() {
    return this._hasFeaturedCard ? this._featuredCard : JsonToString.default;
  }
  get hasFeaturedCard() {
    return this._hasFeaturedCard;
  }
  setFeaturedCard(path, value) {
    return {type: 'SET', path: path.concat(['featuredCard']), value};
  }
  deleteFeaturedCard(path) {
    return {type: 'DELETE', path: path.concat(['featuredCard'])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardSkin}
   */
  get featuredSkin() {
    return this._hasFeaturedSkin ? this._featuredSkin : dcei_wildsky_card_proto.CardSkin.default;
  }
  get hasFeaturedSkin() {
    return this._hasFeaturedSkin;
  }
  setFeaturedSkin(path, value) {
    return {type: 'SET', path: path.concat(['featuredSkin']), value: value.toJson()};
  }
  deleteFeaturedSkin(path) {
    return {type: 'DELETE', path: path.concat(['featuredSkin'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasEventName = true;
              copy._eventName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventName) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasEventName = false;
              copy._eventName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasEventLevel = true;
              copy._eventLevel = StoryEvent_EventLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventLevel) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasEventLevel = false;
              copy._eventLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventLevel) {
            const copy = new StoryEvent(this);
            copy._hasEventLevel = true;
            copy._eventLevel = StoryEvent_EventLevel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventLevel.apply(type, path.slice(1), value);
          if (newValue === this._eventLevel) {
            return this;
          }
          const copy = new StoryEvent(this);
          copy._eventLevel = copy._eventLevel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "storyPanel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasStoryPanel = true;
              copy._storyPanel = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStoryPanel) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasStoryPanel = false;
              copy._storyPanel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerLevelTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._triggerTypeCase = 31;
              copy._triggerTypeValue = StoryEvent_PlayerLevelTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._triggerTypeCase !== 31) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._triggerTypeCase = 0;
              copy._triggerTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._triggerTypeCase !== 31) {
            const copy = new StoryEvent(this);
            copy._triggerTypeCase = 31;
            copy._triggerTypeValue = StoryEvent_PlayerLevelTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playerLevelTrigger.apply(type, path.slice(1), value);
          if (newValue === this.playerLevelTrigger) {
            return this;
          }
          const copy = new StoryEvent(this);
          copy._triggerTypeCase = 31;
          copy._triggerTypeValue = newValue;
          return copy;
        }
      }
      case "campaignLevelTrigger": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._triggerTypeCase = 32;
              copy._triggerTypeValue = StoryEvent_CampaignLevelTrigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._triggerTypeCase !== 32) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._triggerTypeCase = 0;
              copy._triggerTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._triggerTypeCase !== 32) {
            const copy = new StoryEvent(this);
            copy._triggerTypeCase = 32;
            copy._triggerTypeValue = StoryEvent_CampaignLevelTrigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.campaignLevelTrigger.apply(type, path.slice(1), value);
          if (newValue === this.campaignLevelTrigger) {
            return this;
          }
          const copy = new StoryEvent(this);
          copy._triggerTypeCase = 32;
          copy._triggerTypeValue = newValue;
          return copy;
        }
      }
      case "cardBoostInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasCardBoostInfo = true;
              copy._cardBoostInfo = StoryEvent_CardBoostInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardBoostInfo) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasCardBoostInfo = false;
              copy._cardBoostInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardBoostInfo) {
            const copy = new StoryEvent(this);
            copy._hasCardBoostInfo = true;
            copy._cardBoostInfo = StoryEvent_CardBoostInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardBoostInfo.apply(type, path.slice(1), value);
          if (newValue === this._cardBoostInfo) {
            return this;
          }
          const copy = new StoryEvent(this);
          copy._cardBoostInfo = copy._cardBoostInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "featuredCard": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasFeaturedCard = true;
              copy._featuredCard = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeaturedCard) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasFeaturedCard = false;
              copy._featuredCard = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "featuredSkin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEvent(this);
              copy._hasFeaturedSkin = true;
              copy._featuredSkin = dcei_wildsky_card_proto.CardSkin.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeaturedSkin) {
                return this;
              }
              const copy = new StoryEvent(this);
              copy._hasFeaturedSkin = false;
              copy._featuredSkin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFeaturedSkin) {
            const copy = new StoryEvent(this);
            copy._hasFeaturedSkin = true;
            copy._featuredSkin = dcei_wildsky_card_proto.CardSkin.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._featuredSkin.apply(type, path.slice(1), value);
          if (newValue === this._featuredSkin) {
            return this;
          }
          const copy = new StoryEvent(this);
          copy._featuredSkin = copy._featuredSkin.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEvent} other
   * @returns {StoryEvent}
   */
  merge(other) {
    const copy = new StoryEvent(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasEventName) {
      copy._hasEventName = true;
      copy._eventName = other._eventName;
    }
    if (other._hasEventLevel) {
      if (copy._hasEventLevel) {
        copy._eventLevel = copy.eventLevel.merge(other.eventLevel);
      } else {
        copy._eventLevel = other._eventLevel;
      }
      copy._hasEventLevel = true;
    }
    if (other._hasStoryPanel) {
      copy._hasStoryPanel = true;
      copy._storyPanel = other._storyPanel;
    }
    if (other._triggerTypeCase === 31) {
      if (this._triggerTypeCase === 31) {
        copy._triggerTypeValue = copy._triggerTypeValue.merge(other._triggerTypeValue);
      } else {
        copy._triggerTypeValue = other._triggerTypeValue;
      }
      copy._triggerTypeCase = 31;
    }
    if (other._triggerTypeCase === 31) {
      if (this._triggerTypeCase === 31) {
        copy._triggerTypeValue = copy._triggerTypeValue.merge(other._triggerTypeValue);
      } else {
        copy._triggerTypeValue = other._triggerTypeValue;
      }
      copy._triggerTypeCase = 31;
    }
    if (other._hasCardBoostInfo) {
      if (copy._hasCardBoostInfo) {
        copy._cardBoostInfo = copy.cardBoostInfo.merge(other.cardBoostInfo);
      } else {
        copy._cardBoostInfo = other._cardBoostInfo;
      }
      copy._hasCardBoostInfo = true;
    }
    if (other._hasFeaturedCard) {
      copy._hasFeaturedCard = true;
      copy._featuredCard = other._featuredCard;
    }
    if (other._hasFeaturedSkin) {
      if (copy._hasFeaturedSkin) {
        copy._featuredSkin = copy.featuredSkin.merge(other.featuredSkin);
      } else {
        copy._featuredSkin = other._featuredSkin;
      }
      copy._hasFeaturedSkin = true;
    }
    return copy;
  }
}
StoryEvent.default = new StoryEvent();
StoryEvent.EventLevel = StoryEvent_EventLevel;
StoryEvent.CardBoostInfo = StoryEvent_CardBoostInfo;
StoryEvent.PlayerLevelTrigger = StoryEvent_PlayerLevelTrigger;
StoryEvent.CampaignLevelTrigger = StoryEvent_CampaignLevelTrigger;
class StoryEvent_Builder {
  constructor(value) {
    this._value = new StoryEvent(value);
  }
  build() {
    return new StoryEvent(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setEventName(value) {
    this._value._hasEventName = true;
    this._value._eventName = value;
    return this;
  }
  deleteEventName() {
    this._value._hasEventName = false;
    this._value._eventName = null;
    return this;
  }
  setEventLevel(value) {
    this._value._hasEventLevel = true;
    this._value._eventLevel = value;
    return this;
  }
  deleteEventLevel() {
    this._value._hasEventLevel = false;
    this._value._eventLevel = null;
    return this;
  }
  setStoryPanel(value) {
    this._value._hasStoryPanel = true;
    this._value._storyPanel = value;
    return this;
  }
  deleteStoryPanel() {
    this._value._hasStoryPanel = false;
    this._value._storyPanel = null;
    return this;
  }
  cleartriggerType() {
    this._value._triggerTypeCase = 0;
    this._value._triggerTypeValue = null;
    return this;
  }
  setPlayerLevelTrigger(value) {
    this._value._triggerTypeCase = 31;
    this._value._triggerTypeValue = value;
    return this;
  }
  setCampaignLevelTrigger(value) {
    this._value._triggerTypeCase = 32;
    this._value._triggerTypeValue = value;
    return this;
  }
  setCardBoostInfo(value) {
    this._value._hasCardBoostInfo = true;
    this._value._cardBoostInfo = value;
    return this;
  }
  deleteCardBoostInfo() {
    this._value._hasCardBoostInfo = false;
    this._value._cardBoostInfo = null;
    return this;
  }
  setFeaturedCard(value) {
    this._value._hasFeaturedCard = true;
    this._value._featuredCard = value;
    return this;
  }
  deleteFeaturedCard() {
    this._value._hasFeaturedCard = false;
    this._value._featuredCard = null;
    return this;
  }
  setFeaturedSkin(value) {
    this._value._hasFeaturedSkin = true;
    this._value._featuredSkin = value;
    return this;
  }
  deleteFeaturedSkin() {
    this._value._hasFeaturedSkin = false;
    this._value._featuredSkin = null;
    return this;
  }
}
StoryEvent.Builder = StoryEvent_Builder;
class StoryEvent_WithParent {
  /**
   * @param {StoryEvent} value
   * @param {StoryEvent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEvent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasEventName() {
    if (this._cachedHasEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedHasEventName = true;
      } else {
        this._cachedHasEventName = this._parent ? this._parent.hasEventName : false;
      }
    }
    return this._cachedHasEventName;
  }
  get eventName() {
    if (this._cachedEventName === undefined) {
      if (this._value.hasEventName) {
        this._cachedEventName = this._value.eventName;
      } else {
        this._cachedEventName = this._parent ? this._parent.eventName : this._value.eventName;
      }
    }
    return this._cachedEventName;
  }
  get hasEventLevel() {
    if (this._cachedHasEventLevel === undefined) {
      if (this._value.hasEventLevel) {
        this._cachedHasEventLevel = true;
      } else {
        this._cachedHasEventLevel = this._parent ? this._parent.hasEventLevel : false;
      }
    }
    return this._cachedHasEventLevel;
  }
  get eventLevel() {
    if (!this._cachedEventLevel) {
      if (this._value.hasEventLevel) {
        this._cachedEventLevel = new StoryEvent_EventLevel.WithParent(this._value.eventLevel, this._parent && this._parent.hasEventLevel ? this._parent.eventLevel : null);
      } else {
        this._cachedEventLevel = this._parent ? new StoryEvent_EventLevel.WithParent(StoryEvent_EventLevel.default, this._parent.eventLevel) : StoryEvent_EventLevel.WithParent.default;
      }
    }
    return this._cachedEventLevel;
  }
  get hasStoryPanel() {
    if (this._cachedHasStoryPanel === undefined) {
      if (this._value.hasStoryPanel) {
        this._cachedHasStoryPanel = true;
      } else {
        this._cachedHasStoryPanel = this._parent ? this._parent.hasStoryPanel : false;
      }
    }
    return this._cachedHasStoryPanel;
  }
  get storyPanel() {
    if (this._cachedStoryPanel === undefined) {
      if (this._value.hasStoryPanel) {
        this._cachedStoryPanel = this._value.storyPanel;
      } else {
        this._cachedStoryPanel = this._parent ? this._parent.storyPanel : this._value.storyPanel;
      }
    }
    return this._cachedStoryPanel;
  }
  get triggerTypeCase() {
    if (this._cachedtriggerTypeCase === undefined) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedtriggerTypeCase = this._parent ? this._parent.triggerTypeCase : 0;
      } else {
        this._cachedtriggerTypeCase = this._value._triggerTypeCase;
      }
    }
    return this._cachedtriggerTypeCase;
  }
  get playerLevelTrigger() {
    if (!this._cachedPlayerLevelTrigger) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedPlayerLevelTrigger = this._parent ? new StoryEvent_PlayerLevelTrigger.WithParent(StoryEvent_PlayerLevelTrigger.default, this._parent.playerLevelTrigger) : this._value.playerLevelTrigger;
      } else if (this._value._triggerTypeCase === 31) {
        this._cachedPlayerLevelTrigger = new StoryEvent_PlayerLevelTrigger.WithParent(this._value.playerLevelTrigger, this._parent && this._parent.triggerTypeCase === 31 ? this._parent.playerLevelTrigger : null);
      } else {
        this._cachedPlayerLevelTrigger = StoryEvent_PlayerLevelTrigger.WithParent.default;
      }
    }
    return this._cachedPlayerLevelTrigger;
  }
  get campaignLevelTrigger() {
    if (!this._cachedCampaignLevelTrigger) {
      if (this._value._triggerTypeCase === 0) {
        this._cachedCampaignLevelTrigger = this._parent ? new StoryEvent_CampaignLevelTrigger.WithParent(StoryEvent_CampaignLevelTrigger.default, this._parent.campaignLevelTrigger) : this._value.campaignLevelTrigger;
      } else if (this._value._triggerTypeCase === 32) {
        this._cachedCampaignLevelTrigger = new StoryEvent_CampaignLevelTrigger.WithParent(this._value.campaignLevelTrigger, this._parent && this._parent.triggerTypeCase === 32 ? this._parent.campaignLevelTrigger : null);
      } else {
        this._cachedCampaignLevelTrigger = StoryEvent_CampaignLevelTrigger.WithParent.default;
      }
    }
    return this._cachedCampaignLevelTrigger;
  }
  get hasCardBoostInfo() {
    if (this._cachedHasCardBoostInfo === undefined) {
      if (this._value.hasCardBoostInfo) {
        this._cachedHasCardBoostInfo = true;
      } else {
        this._cachedHasCardBoostInfo = this._parent ? this._parent.hasCardBoostInfo : false;
      }
    }
    return this._cachedHasCardBoostInfo;
  }
  get cardBoostInfo() {
    if (!this._cachedCardBoostInfo) {
      if (this._value.hasCardBoostInfo) {
        this._cachedCardBoostInfo = new StoryEvent_CardBoostInfo.WithParent(this._value.cardBoostInfo, this._parent && this._parent.hasCardBoostInfo ? this._parent.cardBoostInfo : null);
      } else {
        this._cachedCardBoostInfo = this._parent ? new StoryEvent_CardBoostInfo.WithParent(StoryEvent_CardBoostInfo.default, this._parent.cardBoostInfo) : StoryEvent_CardBoostInfo.WithParent.default;
      }
    }
    return this._cachedCardBoostInfo;
  }
  get hasFeaturedCard() {
    if (this._cachedHasFeaturedCard === undefined) {
      if (this._value.hasFeaturedCard) {
        this._cachedHasFeaturedCard = true;
      } else {
        this._cachedHasFeaturedCard = this._parent ? this._parent.hasFeaturedCard : false;
      }
    }
    return this._cachedHasFeaturedCard;
  }
  get featuredCard() {
    if (this._cachedFeaturedCard === undefined) {
      if (this._value.hasFeaturedCard) {
        this._cachedFeaturedCard = this._value.featuredCard;
      } else {
        this._cachedFeaturedCard = this._parent ? this._parent.featuredCard : this._value.featuredCard;
      }
    }
    return this._cachedFeaturedCard;
  }
  get hasFeaturedSkin() {
    if (this._cachedHasFeaturedSkin === undefined) {
      if (this._value.hasFeaturedSkin) {
        this._cachedHasFeaturedSkin = true;
      } else {
        this._cachedHasFeaturedSkin = this._parent ? this._parent.hasFeaturedSkin : false;
      }
    }
    return this._cachedHasFeaturedSkin;
  }
  get featuredSkin() {
    if (!this._cachedFeaturedSkin) {
      if (this._value.hasFeaturedSkin) {
        this._cachedFeaturedSkin = new dcei_wildsky_card_proto.CardSkin.WithParent(this._value.featuredSkin, this._parent && this._parent.hasFeaturedSkin ? this._parent.featuredSkin : null);
      } else {
        this._cachedFeaturedSkin = this._parent ? new dcei_wildsky_card_proto.CardSkin.WithParent(dcei_wildsky_card_proto.CardSkin.default, this._parent.featuredSkin) : dcei_wildsky_card_proto.CardSkin.WithParent.default;
      }
    }
    return this._cachedFeaturedSkin;
  }
  update(current, parent) {
    const result = new StoryEvent_WithParent(current, parent);
    if (this._cachedEventLevel && this._value.hasEventLevel && current.hasEventLevel) {
      if (this._value.eventLevel === current.eventLevel && this._parent === parent) {
        result._cachedEventLevel = this._cachedEventLevel;
      } else {
        result._cachedEventLevel = this._cachedEventLevel.update(current.eventLevel, parent && parent.hasEventLevel ? parent.eventLevel : null);
      }
    }
    if (this._cachedPlayerLevelTrigger && this._value._triggerTypeCase === 31 && current._triggerTypeCase === 31) {
      if (this._value.playerLevelTrigger === current.playerLevelTrigger && this._parent === parent) {
        result._cachedPlayerLevelTrigger = this._cachedPlayerLevelTrigger;
      } else {
        result._cachedPlayerLevelTrigger = this._cachedPlayerLevelTrigger.update(current.playerLevelTrigger, parent && parent.triggerTypeCase === 31 ? parent.playerLevelTrigger : null);
      }
    }
    if (this._cachedCampaignLevelTrigger && this._value._triggerTypeCase === 32 && current._triggerTypeCase === 32) {
      if (this._value.campaignLevelTrigger === current.campaignLevelTrigger && this._parent === parent) {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger;
      } else {
        result._cachedCampaignLevelTrigger = this._cachedCampaignLevelTrigger.update(current.campaignLevelTrigger, parent && parent.triggerTypeCase === 32 ? parent.campaignLevelTrigger : null);
      }
    }
    if (this._cachedCardBoostInfo && this._value.hasCardBoostInfo && current.hasCardBoostInfo) {
      if (this._value.cardBoostInfo === current.cardBoostInfo && this._parent === parent) {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo;
      } else {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo.update(current.cardBoostInfo, parent && parent.hasCardBoostInfo ? parent.cardBoostInfo : null);
      }
    }
    if (this._cachedFeaturedSkin && this._value.hasFeaturedSkin && current.hasFeaturedSkin) {
      if (this._value.featuredSkin === current.featuredSkin && this._parent === parent) {
        result._cachedFeaturedSkin = this._cachedFeaturedSkin;
      } else {
        result._cachedFeaturedSkin = this._cachedFeaturedSkin.update(current.featuredSkin, parent && parent.hasFeaturedSkin ? parent.featuredSkin : null);
      }
    }
    return result;
  }
}
StoryEvent_WithParent.default = new StoryEvent_WithParent(StoryEvent.default, null);
StoryEvent.WithParent = StoryEvent_WithParent;
class StoryEvent_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get eventName() {
    if (!this._eventName) {
      this._eventName = {
        name: "eventName",
        Name: "EventName",
        number: 20,
        protoType: 9,
        protoName: "event_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventName;
  }
  get eventLevel() {
    if (!this._eventLevel) {
      this._eventLevel = {
        name: "eventLevel",
        Name: "EventLevel",
        number: 11,
        protoType: 11,
        protoName: "event_level",
        type: StoryEvent_EventLevel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventLevel;
  }
  get storyPanel() {
    if (!this._storyPanel) {
      this._storyPanel = {
        name: "storyPanel",
        Name: "StoryPanel",
        number: 25,
        protoType: 9,
        protoName: "story_panel",
        type: JsonToString,
        options: {
          valueDropdown: "MapEventOverviewPanels",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storyPanel;
  }
  get playerLevelTrigger() {
    if (!this._playerLevelTrigger) {
      this._playerLevelTrigger = {
        name: "playerLevelTrigger",
        Name: "PlayerLevelTrigger",
        number: 31,
        protoType: 11,
        protoName: "player_level_trigger",
        oneofIndex: 4,
        type: StoryEvent_PlayerLevelTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelTrigger;
  }
  get campaignLevelTrigger() {
    if (!this._campaignLevelTrigger) {
      this._campaignLevelTrigger = {
        name: "campaignLevelTrigger",
        Name: "CampaignLevelTrigger",
        number: 32,
        protoType: 11,
        protoName: "campaign_level_trigger",
        oneofIndex: 4,
        type: StoryEvent_CampaignLevelTrigger,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignLevelTrigger;
  }
  get cardBoostInfo() {
    if (!this._cardBoostInfo) {
      this._cardBoostInfo = {
        name: "cardBoostInfo",
        Name: "CardBoostInfo",
        number: 50,
        protoType: 11,
        protoName: "card_boost_info",
        type: StoryEvent_CardBoostInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardBoostInfo;
  }
  get featuredCard() {
    if (!this._featuredCard) {
      this._featuredCard = {
        name: "featuredCard",
        Name: "FeaturedCard",
        number: 51,
        protoType: 9,
        protoName: "featured_card",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featuredCard;
  }
  get featuredSkin() {
    if (!this._featuredSkin) {
      this._featuredSkin = {
        name: "featuredSkin",
        Name: "FeaturedSkin",
        number: 52,
        protoType: 11,
        protoName: "featured_skin",
        type: dcei_wildsky_card_proto.CardSkin,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featuredSkin;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.eventName,
        this.eventLevel,
        this.storyPanel,
        this.playerLevelTrigger,
        this.campaignLevelTrigger,
        this.cardBoostInfo,
        this.featuredCard,
        this.featuredSkin,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventName",
        Name: "DummyOneofForEventName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventLevel",
        Name: "DummyOneofForEventLevel",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStoryPanel",
        Name: "DummyOneofForStoryPanel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "triggerType",
        Name: "TriggerType",
        fields: [
          this.fields[4],
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardBoostInfo",
        Name: "DummyOneofForCardBoostInfo",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeaturedCard",
        Name: "DummyOneofForFeaturedCard",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeaturedSkin",
        Name: "DummyOneofForFeaturedSkin",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEvent.descriptor = new StoryEvent_Descriptor();
export class StoryEventData {
  get descriptor() {
    return StoryEventData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._storyEvents = [];
    this._hasDataVersion = false;
    this._dataVersion = null;
  }
  isEmpty() {
    if (this._storyEvents.length > 0) return false;
    if (this._hasDataVersion) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEventData) {
      return value;
    }
    return StoryEventData.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEventData();
    result._storyEvents = JsonToList(json.storyEvents, StoryEvent);
    if (json.dataVersion != null) {
      result._hasDataVersion = true;
      result._dataVersion = JsonToString.fromJson(json.dataVersion);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._storyEvents.length > 0) {
      result.storyEvents = ArrayToJson(this._storyEvents, StoryEvent);
    }
    if (this._hasDataVersion) {
      result.dataVersion = JsonToString.toJson(this._dataVersion);
    }
    return result;
  }
  /**
   * @returns {StoryEvent[]}
   */
  get storyEvents() {
    return this._storyEvents;
  }
  addStoryEvents(path, value) {
    return {type: 'ADD', path: path.concat(['storyEvents']), value: value.toJson()};
  }
  setStoryEvents(path, value) {
    return {type: 'SET', path: path.concat(['storyEvents']), value: ArrayToJson(value, StoryEvent)};
  }
  setStoryEventsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['storyEvents', key]), value: value.toJson()};
  }
  deleteStoryEvents(path) {
    return {type: 'DELETE', path: path.concat(['storyEvents'])};
  }
  deleteStoryEventsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['storyEvents', key])};
  }
  /**
   * @returns {string}
   */
  get dataVersion() {
    return this._hasDataVersion ? this._dataVersion : JsonToString.default;
  }
  get hasDataVersion() {
    return this._hasDataVersion;
  }
  setDataVersion(path, value) {
    return {type: 'SET', path: path.concat(['dataVersion']), value};
  }
  deleteDataVersion(path) {
    return {type: 'DELETE', path: path.concat(['dataVersion'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storyEvents": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventData(this);
              copy._storyEvents = [];        for (let i of value) {
                copy._storyEvents.push(StoryEvent.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEventData(this);
              copy._storyEvents = copy._storyEvents.concat([StoryEvent.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._storyEvents.length === 0) {
                return this;
              }
              const copy = new StoryEventData(this);
              copy._storyEvents = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._storyEvents.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEventData(this);
              copy._storyEvents = copy._storyEvents.slice();
              copy._storyEvents[path[1]] = StoryEvent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEventData(this);
              copy._storyEvents = copy._storyEvents.slice(0, path[1]).concat(copy._storyEvents.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._storyEvents.length) {
            return this;
          }
          const oldValue = this._storyEvents[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEventData(this);
          copy._storyEvents = copy._storyEvents.slice();
          copy._storyEvents[key] = newValue;
          return copy;
        }
      }
      case "dataVersion": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventData(this);
              copy._hasDataVersion = true;
              copy._dataVersion = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDataVersion) {
                return this;
              }
              const copy = new StoryEventData(this);
              copy._hasDataVersion = false;
              copy._dataVersion = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEventData} other
   * @returns {StoryEventData}
   */
  merge(other) {
    const copy = new StoryEventData(this);
    copy._storyEvents = this._storyEvents.concat(other._storyEvents);
    if (other._hasDataVersion) {
      copy._hasDataVersion = true;
      copy._dataVersion = other._dataVersion;
    }
    return copy;
  }
}
StoryEventData.default = new StoryEventData();
class StoryEventData_Builder {
  constructor(value) {
    this._value = new StoryEventData(value);
  }
  build() {
    return new StoryEventData(this._value);
  }
  addAllStoryEvents(values) {
    this._value._storyEvents = this._value._storyEvents.concat(values);
    return this;
  }
  addStoryEvents(value) {
    this._value._storyEvents = this._value._storyEvents.concat([value]);
    return this;
  }
  setStoryEvents(index, value) {
    this._value._storyEvents = this._value._storyEvents.concat();
    this._value._storyEvents[index] = value;
    return this;
  }
  clearStoryEvents() {
    this._value._storyEvents = [];
    return this;
  }
  setDataVersion(value) {
    this._value._hasDataVersion = true;
    this._value._dataVersion = value;
    return this;
  }
  deleteDataVersion() {
    this._value._hasDataVersion = false;
    this._value._dataVersion = null;
    return this;
  }
}
StoryEventData.Builder = StoryEventData_Builder;
class StoryEventData_WithParent {
  /**
   * @param {StoryEventData} value
   * @param {StoryEventData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEventData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfStoryEvents() {
    if (!this._selfStoryEvents) {
      this._selfStoryEvents = [];
      for (let i of this._value.storyEvents) {
        this._selfStoryEvents.push(new StoryEvent.WithParent(i, null));
      }
    }
    return this._selfStoryEvents;
  }
  get inherentStoryEvents() {
    if (!this._inherentStoryEvents) {
      this._inherentStoryEvents = this._parent ? this._parent.storyEvents : [];
    }
    return this._inherentStoryEvents;
  }
  get storyEvents() {
    if (!this._allStoryEvents) {
      this._allStoryEvents = this._parent ? this._parent.storyEvents.concat(this.selfStoryEvents) : this.selfStoryEvents;
    }
    return this._allStoryEvents;
  }
  get hasDataVersion() {
    if (this._cachedHasDataVersion === undefined) {
      if (this._value.hasDataVersion) {
        this._cachedHasDataVersion = true;
      } else {
        this._cachedHasDataVersion = this._parent ? this._parent.hasDataVersion : false;
      }
    }
    return this._cachedHasDataVersion;
  }
  get dataVersion() {
    if (this._cachedDataVersion === undefined) {
      if (this._value.hasDataVersion) {
        this._cachedDataVersion = this._value.dataVersion;
      } else {
        this._cachedDataVersion = this._parent ? this._parent.dataVersion : this._value.dataVersion;
      }
    }
    return this._cachedDataVersion;
  }
  update(current, parent) {
    const result = new StoryEventData_WithParent(current, parent);
    if (this._selfStoryEvents) {
      if (this._value.storyEvents === current.storyEvents) {
        result._selfStoryEvents = this._selfStoryEvents;
      } else {
        result._selfStoryEvents = [];
        for (let i = 0; i < current.storyEvents.length; i++) {
          const oldValue = this._value.storyEvents[i];
          if (oldValue) {
            const oldCache = this._selfStoryEvents[i];
            if (oldValue === current.storyEvents[i]) {
              result._selfStoryEvents[i] = oldCache;
            } else {
              result._selfStoryEvents[i] = oldCache.update(current.storyEvents[i], null);
            }
          } else {
            result._selfStoryEvents[i] = new StoryEvent.WithParent(current.storyEvents[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEventData_WithParent.default = new StoryEventData_WithParent(StoryEventData.default, null);
StoryEventData.WithParent = StoryEventData_WithParent;
class StoryEventData_Descriptor {
  get storyEvents() {
    if (!this._storyEvents) {
      this._storyEvents = {
        name: "storyEvents",
        Name: "StoryEvents",
        number: 1,
        protoType: 11,
        protoName: "story_events",
        type: StoryEvent,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storyEvents;
  }
  get dataVersion() {
    if (!this._dataVersion) {
      this._dataVersion = {
        name: "dataVersion",
        Name: "DataVersion",
        number: 3,
        protoType: 9,
        protoName: "data_version",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dataVersion;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storyEvents,
        this.dataVersion,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDataVersion",
        Name: "DummyOneofForDataVersion",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEventData.descriptor = new StoryEventData_Descriptor();
class StoryEventStatus_SoloLevelStatus_DifficultyStatus {
  get descriptor() {
    return StoryEventStatus_SoloLevelStatus_DifficultyStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDifficulty = false;
    this._difficulty = null;
    this._hasState = false;
    this._state = null;
  }
  isEmpty() {
    if (this._hasDifficulty) return false;
    if (this._hasState) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEventStatus_SoloLevelStatus_DifficultyStatus) {
      return value;
    }
    return StoryEventStatus_SoloLevelStatus_DifficultyStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEventStatus_SoloLevelStatus_DifficultyStatus();
    if (json.difficulty != null) {
      result._hasDifficulty = true;
      result._difficulty = JsonToInt32.fromJson(json.difficulty);
    }
    if (json.state != null) {
      result._hasState = true;
      result._state = StoryEventStatus_SoloLevelStatus_LevelState.fromJson(json.state);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDifficulty) {
      result.difficulty = JsonToInt32.toJson(this._difficulty);
    }
    if (this._hasState) {
      result.state = StoryEventStatus_SoloLevelStatus_LevelState.toJson(this._state);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get difficulty() {
    return this._hasDifficulty ? this._difficulty : JsonToInt32.default;
  }
  get hasDifficulty() {
    return this._hasDifficulty;
  }
  setDifficulty(path, value) {
    return {type: 'SET', path: path.concat(['difficulty']), value};
  }
  deleteDifficulty(path) {
    return {type: 'DELETE', path: path.concat(['difficulty'])};
  }
  /**
   * @returns {number}
   */
  get state() {
    return this._hasState ? this._state : StoryEventStatus_SoloLevelStatus_LevelState.default;
  }
  get hasState() {
    return this._hasState;
  }
  setState(path, value) {
    return {type: 'SET', path: path.concat(['state']), value};
  }
  deleteState(path) {
    return {type: 'DELETE', path: path.concat(['state'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "difficulty": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasDifficulty = true;
              copy._difficulty = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDifficulty) {
                return this;
              }
              const copy = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasDifficulty = false;
              copy._difficulty = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "state": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasState = true;
              copy._state = StoryEventStatus_SoloLevelStatus_LevelState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasState) {
                return this;
              }
              const copy = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this);
              copy._hasState = false;
              copy._state = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEventStatus_SoloLevelStatus_DifficultyStatus} other
   * @returns {StoryEventStatus_SoloLevelStatus_DifficultyStatus}
   */
  merge(other) {
    const copy = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this);
    if (other._hasDifficulty) {
      copy._hasDifficulty = true;
      copy._difficulty = other._difficulty;
    }
    if (other._hasState) {
      copy._hasState = true;
      copy._state = other._state;
    }
    return copy;
  }
}
StoryEventStatus_SoloLevelStatus_DifficultyStatus.default = new StoryEventStatus_SoloLevelStatus_DifficultyStatus();
class StoryEventStatus_SoloLevelStatus_DifficultyStatus_Builder {
  constructor(value) {
    this._value = new StoryEventStatus_SoloLevelStatus_DifficultyStatus(value);
  }
  build() {
    return new StoryEventStatus_SoloLevelStatus_DifficultyStatus(this._value);
  }
  setDifficulty(value) {
    this._value._hasDifficulty = true;
    this._value._difficulty = value;
    return this;
  }
  deleteDifficulty() {
    this._value._hasDifficulty = false;
    this._value._difficulty = null;
    return this;
  }
  setState(value) {
    this._value._hasState = true;
    this._value._state = value;
    return this;
  }
  deleteState() {
    this._value._hasState = false;
    this._value._state = null;
    return this;
  }
}
StoryEventStatus_SoloLevelStatus_DifficultyStatus.Builder = StoryEventStatus_SoloLevelStatus_DifficultyStatus_Builder;
class StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent {
  /**
   * @param {StoryEventStatus_SoloLevelStatus_DifficultyStatus} value
   * @param {StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEventStatus_SoloLevelStatus_DifficultyStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDifficulty() {
    if (this._cachedHasDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedHasDifficulty = true;
      } else {
        this._cachedHasDifficulty = this._parent ? this._parent.hasDifficulty : false;
      }
    }
    return this._cachedHasDifficulty;
  }
  get difficulty() {
    if (this._cachedDifficulty === undefined) {
      if (this._value.hasDifficulty) {
        this._cachedDifficulty = this._value.difficulty;
      } else {
        this._cachedDifficulty = this._parent ? this._parent.difficulty : this._value.difficulty;
      }
    }
    return this._cachedDifficulty;
  }
  get hasState() {
    if (this._cachedHasState === undefined) {
      if (this._value.hasState) {
        this._cachedHasState = true;
      } else {
        this._cachedHasState = this._parent ? this._parent.hasState : false;
      }
    }
    return this._cachedHasState;
  }
  get state() {
    if (this._cachedState === undefined) {
      if (this._value.hasState) {
        this._cachedState = this._value.state;
      } else {
        this._cachedState = this._parent ? this._parent.state : this._value.state;
      }
    }
    return this._cachedState;
  }
  update(current, parent) {
    const result = new StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent(current, parent);
    return result;
  }
}
StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent.default = new StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent(StoryEventStatus_SoloLevelStatus_DifficultyStatus.default, null);
StoryEventStatus_SoloLevelStatus_DifficultyStatus.WithParent = StoryEventStatus_SoloLevelStatus_DifficultyStatus_WithParent;
class StoryEventStatus_SoloLevelStatus_DifficultyStatus_Descriptor {
  get difficulty() {
    if (!this._difficulty) {
      this._difficulty = {
        name: "difficulty",
        Name: "Difficulty",
        number: 1,
        protoType: 5,
        protoName: "difficulty",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficulty;
  }
  get state() {
    if (!this._state) {
      this._state = {
        name: "state",
        Name: "State",
        number: 2,
        protoType: 14,
        protoName: "state",
        type: StoryEventStatus_SoloLevelStatus_LevelState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._state;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.difficulty,
        this.state,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDifficulty",
        Name: "DummyOneofForDifficulty",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForState",
        Name: "DummyOneofForState",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEventStatus_SoloLevelStatus_DifficultyStatus.descriptor = new StoryEventStatus_SoloLevelStatus_DifficultyStatus_Descriptor();
class StoryEventStatus_SoloLevelStatus_LevelState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LOCKED": return 0;
        case "UNLOCKED": return 1;
        case "FINISHED": return 2;
        case "PERFECT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return StoryEventStatus_SoloLevelStatus_LevelState.fromJson(value);
  }
  static fromReact(e) {
    return StoryEventStatus_SoloLevelStatus_LevelState.fromJson(e);
  }
}
StoryEventStatus_SoloLevelStatus_LevelState.LOCKED = 0;
StoryEventStatus_SoloLevelStatus_LevelState.UNLOCKED = 1;
StoryEventStatus_SoloLevelStatus_LevelState.FINISHED = 2;
StoryEventStatus_SoloLevelStatus_LevelState.PERFECT = 3;
StoryEventStatus_SoloLevelStatus_LevelState.default = 0;
StoryEventStatus_SoloLevelStatus_LevelState.values = {
  LOCKED: 0,
  UNLOCKED: 1,
  FINISHED: 2,
  PERFECT: 3,
};
StoryEventStatus_SoloLevelStatus_LevelState.names = {
  0: "LOCKED",
  1: "UNLOCKED",
  2: "FINISHED",
  3: "PERFECT",
};
class StoryEventStatus_SoloLevelStatus {
  get descriptor() {
    return StoryEventStatus_SoloLevelStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasState = false;
    this._state = null;
    this._hasLevelIndex = false;
    this._levelIndex = null;
    this._difficultyStatus = [];
  }
  isEmpty() {
    if (this._hasState) return false;
    if (this._hasLevelIndex) return false;
    if (this._difficultyStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEventStatus_SoloLevelStatus) {
      return value;
    }
    return StoryEventStatus_SoloLevelStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEventStatus_SoloLevelStatus();
    if (json.state != null) {
      result._hasState = true;
      result._state = StoryEventStatus_SoloLevelStatus_LevelState.fromJson(json.state);
    }
    if (json.levelIndex != null) {
      result._hasLevelIndex = true;
      result._levelIndex = JsonToInt32.fromJson(json.levelIndex);
    }
    result._difficultyStatus = JsonToList(json.difficultyStatus, StoryEventStatus_SoloLevelStatus_DifficultyStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasState) {
      result.state = StoryEventStatus_SoloLevelStatus_LevelState.toJson(this._state);
    }
    if (this._hasLevelIndex) {
      result.levelIndex = JsonToInt32.toJson(this._levelIndex);
    }
    if (this._difficultyStatus.length > 0) {
      result.difficultyStatus = ArrayToJson(this._difficultyStatus, StoryEventStatus_SoloLevelStatus_DifficultyStatus);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get state() {
    return this._hasState ? this._state : StoryEventStatus_SoloLevelStatus_LevelState.default;
  }
  get hasState() {
    return this._hasState;
  }
  setState(path, value) {
    return {type: 'SET', path: path.concat(['state']), value};
  }
  deleteState(path) {
    return {type: 'DELETE', path: path.concat(['state'])};
  }
  /**
   * @returns {number}
   */
  get levelIndex() {
    return this._hasLevelIndex ? this._levelIndex : JsonToInt32.default;
  }
  get hasLevelIndex() {
    return this._hasLevelIndex;
  }
  setLevelIndex(path, value) {
    return {type: 'SET', path: path.concat(['levelIndex']), value};
  }
  deleteLevelIndex(path) {
    return {type: 'DELETE', path: path.concat(['levelIndex'])};
  }
  /**
   * @returns {StoryEventStatus_SoloLevelStatus_DifficultyStatus[]}
   */
  get difficultyStatus() {
    return this._difficultyStatus;
  }
  addDifficultyStatus(path, value) {
    return {type: 'ADD', path: path.concat(['difficultyStatus']), value: value.toJson()};
  }
  setDifficultyStatus(path, value) {
    return {type: 'SET', path: path.concat(['difficultyStatus']), value: ArrayToJson(value, StoryEventStatus_SoloLevelStatus_DifficultyStatus)};
  }
  setDifficultyStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['difficultyStatus', key]), value: value.toJson()};
  }
  deleteDifficultyStatus(path) {
    return {type: 'DELETE', path: path.concat(['difficultyStatus'])};
  }
  deleteDifficultyStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['difficultyStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "state": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._hasState = true;
              copy._state = StoryEventStatus_SoloLevelStatus_LevelState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasState) {
                return this;
              }
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._hasState = false;
              copy._state = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._hasLevelIndex = true;
              copy._levelIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelIndex) {
                return this;
              }
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._hasLevelIndex = false;
              copy._levelIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "difficultyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = [];        for (let i of value) {
                copy._difficultyStatus.push(StoryEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.concat([StoryEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._difficultyStatus.length === 0) {
                return this;
              }
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._difficultyStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.slice();
              copy._difficultyStatus[path[1]] = StoryEventStatus_SoloLevelStatus_DifficultyStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEventStatus_SoloLevelStatus(this);
              copy._difficultyStatus = copy._difficultyStatus.slice(0, path[1]).concat(copy._difficultyStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._difficultyStatus.length) {
            return this;
          }
          const oldValue = this._difficultyStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEventStatus_SoloLevelStatus(this);
          copy._difficultyStatus = copy._difficultyStatus.slice();
          copy._difficultyStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEventStatus_SoloLevelStatus} other
   * @returns {StoryEventStatus_SoloLevelStatus}
   */
  merge(other) {
    const copy = new StoryEventStatus_SoloLevelStatus(this);
    if (other._hasState) {
      copy._hasState = true;
      copy._state = other._state;
    }
    if (other._hasLevelIndex) {
      copy._hasLevelIndex = true;
      copy._levelIndex = other._levelIndex;
    }
    copy._difficultyStatus = this._difficultyStatus.concat(other._difficultyStatus);
    return copy;
  }
}
StoryEventStatus_SoloLevelStatus.default = new StoryEventStatus_SoloLevelStatus();
StoryEventStatus_SoloLevelStatus.DifficultyStatus = StoryEventStatus_SoloLevelStatus_DifficultyStatus;
StoryEventStatus_SoloLevelStatus.LevelState = StoryEventStatus_SoloLevelStatus_LevelState;
class StoryEventStatus_SoloLevelStatus_Builder {
  constructor(value) {
    this._value = new StoryEventStatus_SoloLevelStatus(value);
  }
  build() {
    return new StoryEventStatus_SoloLevelStatus(this._value);
  }
  setState(value) {
    this._value._hasState = true;
    this._value._state = value;
    return this;
  }
  deleteState() {
    this._value._hasState = false;
    this._value._state = null;
    return this;
  }
  setLevelIndex(value) {
    this._value._hasLevelIndex = true;
    this._value._levelIndex = value;
    return this;
  }
  deleteLevelIndex() {
    this._value._hasLevelIndex = false;
    this._value._levelIndex = null;
    return this;
  }
  addAllDifficultyStatus(values) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat(values);
    return this;
  }
  addDifficultyStatus(value) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat([value]);
    return this;
  }
  setDifficultyStatus(index, value) {
    this._value._difficultyStatus = this._value._difficultyStatus.concat();
    this._value._difficultyStatus[index] = value;
    return this;
  }
  clearDifficultyStatus() {
    this._value._difficultyStatus = [];
    return this;
  }
}
StoryEventStatus_SoloLevelStatus.Builder = StoryEventStatus_SoloLevelStatus_Builder;
class StoryEventStatus_SoloLevelStatus_WithParent {
  /**
   * @param {StoryEventStatus_SoloLevelStatus} value
   * @param {StoryEventStatus_SoloLevelStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEventStatus_SoloLevelStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasState() {
    if (this._cachedHasState === undefined) {
      if (this._value.hasState) {
        this._cachedHasState = true;
      } else {
        this._cachedHasState = this._parent ? this._parent.hasState : false;
      }
    }
    return this._cachedHasState;
  }
  get state() {
    if (this._cachedState === undefined) {
      if (this._value.hasState) {
        this._cachedState = this._value.state;
      } else {
        this._cachedState = this._parent ? this._parent.state : this._value.state;
      }
    }
    return this._cachedState;
  }
  get hasLevelIndex() {
    if (this._cachedHasLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedHasLevelIndex = true;
      } else {
        this._cachedHasLevelIndex = this._parent ? this._parent.hasLevelIndex : false;
      }
    }
    return this._cachedHasLevelIndex;
  }
  get levelIndex() {
    if (this._cachedLevelIndex === undefined) {
      if (this._value.hasLevelIndex) {
        this._cachedLevelIndex = this._value.levelIndex;
      } else {
        this._cachedLevelIndex = this._parent ? this._parent.levelIndex : this._value.levelIndex;
      }
    }
    return this._cachedLevelIndex;
  }
  get selfDifficultyStatus() {
    if (!this._selfDifficultyStatus) {
      this._selfDifficultyStatus = [];
      for (let i of this._value.difficultyStatus) {
        this._selfDifficultyStatus.push(new StoryEventStatus_SoloLevelStatus_DifficultyStatus.WithParent(i, null));
      }
    }
    return this._selfDifficultyStatus;
  }
  get inherentDifficultyStatus() {
    if (!this._inherentDifficultyStatus) {
      this._inherentDifficultyStatus = this._parent ? this._parent.difficultyStatus : [];
    }
    return this._inherentDifficultyStatus;
  }
  get difficultyStatus() {
    if (!this._allDifficultyStatus) {
      this._allDifficultyStatus = this._parent ? this._parent.difficultyStatus.concat(this.selfDifficultyStatus) : this.selfDifficultyStatus;
    }
    return this._allDifficultyStatus;
  }
  update(current, parent) {
    const result = new StoryEventStatus_SoloLevelStatus_WithParent(current, parent);
    if (this._selfDifficultyStatus) {
      if (this._value.difficultyStatus === current.difficultyStatus) {
        result._selfDifficultyStatus = this._selfDifficultyStatus;
      } else {
        result._selfDifficultyStatus = [];
        for (let i = 0; i < current.difficultyStatus.length; i++) {
          const oldValue = this._value.difficultyStatus[i];
          if (oldValue) {
            const oldCache = this._selfDifficultyStatus[i];
            if (oldValue === current.difficultyStatus[i]) {
              result._selfDifficultyStatus[i] = oldCache;
            } else {
              result._selfDifficultyStatus[i] = oldCache.update(current.difficultyStatus[i], null);
            }
          } else {
            result._selfDifficultyStatus[i] = new StoryEventStatus_SoloLevelStatus_DifficultyStatus.WithParent(current.difficultyStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEventStatus_SoloLevelStatus_WithParent.default = new StoryEventStatus_SoloLevelStatus_WithParent(StoryEventStatus_SoloLevelStatus.default, null);
StoryEventStatus_SoloLevelStatus.WithParent = StoryEventStatus_SoloLevelStatus_WithParent;
class StoryEventStatus_SoloLevelStatus_Descriptor {
  get state() {
    if (!this._state) {
      this._state = {
        name: "state",
        Name: "State",
        number: 2,
        protoType: 14,
        protoName: "state",
        type: StoryEventStatus_SoloLevelStatus_LevelState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._state;
  }
  get levelIndex() {
    if (!this._levelIndex) {
      this._levelIndex = {
        name: "levelIndex",
        Name: "LevelIndex",
        number: 3,
        protoType: 5,
        protoName: "level_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelIndex;
  }
  get difficultyStatus() {
    if (!this._difficultyStatus) {
      this._difficultyStatus = {
        name: "difficultyStatus",
        Name: "DifficultyStatus",
        number: 4,
        protoType: 11,
        protoName: "difficulty_status",
        type: StoryEventStatus_SoloLevelStatus_DifficultyStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._difficultyStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.state,
        this.levelIndex,
        this.difficultyStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForState",
        Name: "DummyOneofForState",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelIndex",
        Name: "DummyOneofForLevelIndex",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEventStatus_SoloLevelStatus.descriptor = new StoryEventStatus_SoloLevelStatus_Descriptor();
class StoryEventStatus_EventState {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "EXPIRED": return 0;
        case "INACTIVATED": return 1;
        case "ACTIVE": return 2;
        case "COMPLETED": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return StoryEventStatus_EventState.fromJson(value);
  }
  static fromReact(e) {
    return StoryEventStatus_EventState.fromJson(e);
  }
}
StoryEventStatus_EventState.EXPIRED = 0;
StoryEventStatus_EventState.INACTIVATED = 1;
StoryEventStatus_EventState.ACTIVE = 2;
StoryEventStatus_EventState.COMPLETED = 3;
StoryEventStatus_EventState.default = 0;
StoryEventStatus_EventState.values = {
  EXPIRED: 0,
  INACTIVATED: 1,
  ACTIVE: 2,
  COMPLETED: 3,
};
StoryEventStatus_EventState.names = {
  0: "EXPIRED",
  1: "INACTIVATED",
  2: "ACTIVE",
  3: "COMPLETED",
};
export class StoryEventStatus {
  get descriptor() {
    return StoryEventStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStoryEventKey = false;
    this._storyEventKey = null;
    this._hasEventState = false;
    this._eventState = null;
    this._soloLevelStatuses = [];
  }
  isEmpty() {
    if (this._hasStoryEventKey) return false;
    if (this._hasEventState) return false;
    if (this._soloLevelStatuses.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof StoryEventStatus) {
      return value;
    }
    return StoryEventStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new StoryEventStatus();
    if (json.storyEventKey != null) {
      result._hasStoryEventKey = true;
      result._storyEventKey = JsonToString.fromJson(json.storyEventKey);
    }
    if (json.eventState != null) {
      result._hasEventState = true;
      result._eventState = StoryEventStatus_EventState.fromJson(json.eventState);
    }
    result._soloLevelStatuses = JsonToList(json.soloLevelStatuses, StoryEventStatus_SoloLevelStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStoryEventKey) {
      result.storyEventKey = JsonToString.toJson(this._storyEventKey);
    }
    if (this._hasEventState) {
      result.eventState = StoryEventStatus_EventState.toJson(this._eventState);
    }
    if (this._soloLevelStatuses.length > 0) {
      result.soloLevelStatuses = ArrayToJson(this._soloLevelStatuses, StoryEventStatus_SoloLevelStatus);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get storyEventKey() {
    return this._hasStoryEventKey ? this._storyEventKey : JsonToString.default;
  }
  get hasStoryEventKey() {
    return this._hasStoryEventKey;
  }
  setStoryEventKey(path, value) {
    return {type: 'SET', path: path.concat(['storyEventKey']), value};
  }
  deleteStoryEventKey(path) {
    return {type: 'DELETE', path: path.concat(['storyEventKey'])};
  }
  /**
   * @returns {number}
   */
  get eventState() {
    return this._hasEventState ? this._eventState : StoryEventStatus_EventState.default;
  }
  get hasEventState() {
    return this._hasEventState;
  }
  setEventState(path, value) {
    return {type: 'SET', path: path.concat(['eventState']), value};
  }
  deleteEventState(path) {
    return {type: 'DELETE', path: path.concat(['eventState'])};
  }
  /**
   * @returns {StoryEventStatus_SoloLevelStatus[]}
   */
  get soloLevelStatuses() {
    return this._soloLevelStatuses;
  }
  addSoloLevelStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['soloLevelStatuses']), value: value.toJson()};
  }
  setSoloLevelStatuses(path, value) {
    return {type: 'SET', path: path.concat(['soloLevelStatuses']), value: ArrayToJson(value, StoryEventStatus_SoloLevelStatus)};
  }
  setSoloLevelStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['soloLevelStatuses', key]), value: value.toJson()};
  }
  deleteSoloLevelStatuses(path) {
    return {type: 'DELETE', path: path.concat(['soloLevelStatuses'])};
  }
  deleteSoloLevelStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['soloLevelStatuses', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storyEventKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus(this);
              copy._hasStoryEventKey = true;
              copy._storyEventKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStoryEventKey) {
                return this;
              }
              const copy = new StoryEventStatus(this);
              copy._hasStoryEventKey = false;
              copy._storyEventKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventState": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus(this);
              copy._hasEventState = true;
              copy._eventState = StoryEventStatus_EventState.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventState) {
                return this;
              }
              const copy = new StoryEventStatus(this);
              copy._hasEventState = false;
              copy._eventState = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "soloLevelStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus(this);
              copy._soloLevelStatuses = [];        for (let i of value) {
                copy._soloLevelStatuses.push(StoryEventStatus_SoloLevelStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new StoryEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.concat([StoryEventStatus_SoloLevelStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._soloLevelStatuses.length === 0) {
                return this;
              }
              const copy = new StoryEventStatus(this);
              copy._soloLevelStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._soloLevelStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new StoryEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.slice();
              copy._soloLevelStatuses[path[1]] = StoryEventStatus_SoloLevelStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new StoryEventStatus(this);
              copy._soloLevelStatuses = copy._soloLevelStatuses.slice(0, path[1]).concat(copy._soloLevelStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._soloLevelStatuses.length) {
            return this;
          }
          const oldValue = this._soloLevelStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new StoryEventStatus(this);
          copy._soloLevelStatuses = copy._soloLevelStatuses.slice();
          copy._soloLevelStatuses[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {StoryEventStatus} other
   * @returns {StoryEventStatus}
   */
  merge(other) {
    const copy = new StoryEventStatus(this);
    if (other._hasStoryEventKey) {
      copy._hasStoryEventKey = true;
      copy._storyEventKey = other._storyEventKey;
    }
    if (other._hasEventState) {
      copy._hasEventState = true;
      copy._eventState = other._eventState;
    }
    copy._soloLevelStatuses = this._soloLevelStatuses.concat(other._soloLevelStatuses);
    return copy;
  }
}
StoryEventStatus.default = new StoryEventStatus();
StoryEventStatus.SoloLevelStatus = StoryEventStatus_SoloLevelStatus;
StoryEventStatus.EventState = StoryEventStatus_EventState;
class StoryEventStatus_Builder {
  constructor(value) {
    this._value = new StoryEventStatus(value);
  }
  build() {
    return new StoryEventStatus(this._value);
  }
  setStoryEventKey(value) {
    this._value._hasStoryEventKey = true;
    this._value._storyEventKey = value;
    return this;
  }
  deleteStoryEventKey() {
    this._value._hasStoryEventKey = false;
    this._value._storyEventKey = null;
    return this;
  }
  setEventState(value) {
    this._value._hasEventState = true;
    this._value._eventState = value;
    return this;
  }
  deleteEventState() {
    this._value._hasEventState = false;
    this._value._eventState = null;
    return this;
  }
  addAllSoloLevelStatuses(values) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat(values);
    return this;
  }
  addSoloLevelStatuses(value) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat([value]);
    return this;
  }
  setSoloLevelStatuses(index, value) {
    this._value._soloLevelStatuses = this._value._soloLevelStatuses.concat();
    this._value._soloLevelStatuses[index] = value;
    return this;
  }
  clearSoloLevelStatuses() {
    this._value._soloLevelStatuses = [];
    return this;
  }
}
StoryEventStatus.Builder = StoryEventStatus_Builder;
class StoryEventStatus_WithParent {
  /**
   * @param {StoryEventStatus} value
   * @param {StoryEventStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return StoryEventStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStoryEventKey() {
    if (this._cachedHasStoryEventKey === undefined) {
      if (this._value.hasStoryEventKey) {
        this._cachedHasStoryEventKey = true;
      } else {
        this._cachedHasStoryEventKey = this._parent ? this._parent.hasStoryEventKey : false;
      }
    }
    return this._cachedHasStoryEventKey;
  }
  get storyEventKey() {
    if (this._cachedStoryEventKey === undefined) {
      if (this._value.hasStoryEventKey) {
        this._cachedStoryEventKey = this._value.storyEventKey;
      } else {
        this._cachedStoryEventKey = this._parent ? this._parent.storyEventKey : this._value.storyEventKey;
      }
    }
    return this._cachedStoryEventKey;
  }
  get hasEventState() {
    if (this._cachedHasEventState === undefined) {
      if (this._value.hasEventState) {
        this._cachedHasEventState = true;
      } else {
        this._cachedHasEventState = this._parent ? this._parent.hasEventState : false;
      }
    }
    return this._cachedHasEventState;
  }
  get eventState() {
    if (this._cachedEventState === undefined) {
      if (this._value.hasEventState) {
        this._cachedEventState = this._value.eventState;
      } else {
        this._cachedEventState = this._parent ? this._parent.eventState : this._value.eventState;
      }
    }
    return this._cachedEventState;
  }
  get selfSoloLevelStatuses() {
    if (!this._selfSoloLevelStatuses) {
      this._selfSoloLevelStatuses = [];
      for (let i of this._value.soloLevelStatuses) {
        this._selfSoloLevelStatuses.push(new StoryEventStatus_SoloLevelStatus.WithParent(i, null));
      }
    }
    return this._selfSoloLevelStatuses;
  }
  get inherentSoloLevelStatuses() {
    if (!this._inherentSoloLevelStatuses) {
      this._inherentSoloLevelStatuses = this._parent ? this._parent.soloLevelStatuses : [];
    }
    return this._inherentSoloLevelStatuses;
  }
  get soloLevelStatuses() {
    if (!this._allSoloLevelStatuses) {
      this._allSoloLevelStatuses = this._parent ? this._parent.soloLevelStatuses.concat(this.selfSoloLevelStatuses) : this.selfSoloLevelStatuses;
    }
    return this._allSoloLevelStatuses;
  }
  update(current, parent) {
    const result = new StoryEventStatus_WithParent(current, parent);
    if (this._selfSoloLevelStatuses) {
      if (this._value.soloLevelStatuses === current.soloLevelStatuses) {
        result._selfSoloLevelStatuses = this._selfSoloLevelStatuses;
      } else {
        result._selfSoloLevelStatuses = [];
        for (let i = 0; i < current.soloLevelStatuses.length; i++) {
          const oldValue = this._value.soloLevelStatuses[i];
          if (oldValue) {
            const oldCache = this._selfSoloLevelStatuses[i];
            if (oldValue === current.soloLevelStatuses[i]) {
              result._selfSoloLevelStatuses[i] = oldCache;
            } else {
              result._selfSoloLevelStatuses[i] = oldCache.update(current.soloLevelStatuses[i], null);
            }
          } else {
            result._selfSoloLevelStatuses[i] = new StoryEventStatus_SoloLevelStatus.WithParent(current.soloLevelStatuses[i], null);
          }
        }
      }
    }
    return result;
  }
}
StoryEventStatus_WithParent.default = new StoryEventStatus_WithParent(StoryEventStatus.default, null);
StoryEventStatus.WithParent = StoryEventStatus_WithParent;
class StoryEventStatus_Descriptor {
  get storyEventKey() {
    if (!this._storyEventKey) {
      this._storyEventKey = {
        name: "storyEventKey",
        Name: "StoryEventKey",
        number: 1,
        protoType: 9,
        protoName: "story_event_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storyEventKey;
  }
  get eventState() {
    if (!this._eventState) {
      this._eventState = {
        name: "eventState",
        Name: "EventState",
        number: 2,
        protoType: 14,
        protoName: "event_state",
        type: StoryEventStatus_EventState,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventState;
  }
  get soloLevelStatuses() {
    if (!this._soloLevelStatuses) {
      this._soloLevelStatuses = {
        name: "soloLevelStatuses",
        Name: "SoloLevelStatuses",
        number: 21,
        protoType: 11,
        protoName: "solo_level_statuses",
        type: StoryEventStatus_SoloLevelStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._soloLevelStatuses;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storyEventKey,
        this.eventState,
        this.soloLevelStatuses,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStoryEventKey",
        Name: "DummyOneofForStoryEventKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventState",
        Name: "DummyOneofForEventState",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
StoryEventStatus.descriptor = new StoryEventStatus_Descriptor();
export class PlayerStoryEventStatus {
  get descriptor() {
    return PlayerStoryEventStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._storyEventStatuses = [];
  }
  isEmpty() {
    if (this._storyEventStatuses.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerStoryEventStatus) {
      return value;
    }
    return PlayerStoryEventStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerStoryEventStatus();
    result._storyEventStatuses = JsonToList(json.storyEventStatuses, StoryEventStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._storyEventStatuses.length > 0) {
      result.storyEventStatuses = ArrayToJson(this._storyEventStatuses, StoryEventStatus);
    }
    return result;
  }
  /**
   * @returns {StoryEventStatus[]}
   */
  get storyEventStatuses() {
    return this._storyEventStatuses;
  }
  addStoryEventStatuses(path, value) {
    return {type: 'ADD', path: path.concat(['storyEventStatuses']), value: value.toJson()};
  }
  setStoryEventStatuses(path, value) {
    return {type: 'SET', path: path.concat(['storyEventStatuses']), value: ArrayToJson(value, StoryEventStatus)};
  }
  setStoryEventStatusesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['storyEventStatuses', key]), value: value.toJson()};
  }
  deleteStoryEventStatuses(path) {
    return {type: 'DELETE', path: path.concat(['storyEventStatuses'])};
  }
  deleteStoryEventStatusesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['storyEventStatuses', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storyEventStatuses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerStoryEventStatus(this);
              copy._storyEventStatuses = [];        for (let i of value) {
                copy._storyEventStatuses.push(StoryEventStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerStoryEventStatus(this);
              copy._storyEventStatuses = copy._storyEventStatuses.concat([StoryEventStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._storyEventStatuses.length === 0) {
                return this;
              }
              const copy = new PlayerStoryEventStatus(this);
              copy._storyEventStatuses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._storyEventStatuses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerStoryEventStatus(this);
              copy._storyEventStatuses = copy._storyEventStatuses.slice();
              copy._storyEventStatuses[path[1]] = StoryEventStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerStoryEventStatus(this);
              copy._storyEventStatuses = copy._storyEventStatuses.slice(0, path[1]).concat(copy._storyEventStatuses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._storyEventStatuses.length) {
            return this;
          }
          const oldValue = this._storyEventStatuses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerStoryEventStatus(this);
          copy._storyEventStatuses = copy._storyEventStatuses.slice();
          copy._storyEventStatuses[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerStoryEventStatus} other
   * @returns {PlayerStoryEventStatus}
   */
  merge(other) {
    const copy = new PlayerStoryEventStatus(this);
    copy._storyEventStatuses = this._storyEventStatuses.concat(other._storyEventStatuses);
    return copy;
  }
}
PlayerStoryEventStatus.default = new PlayerStoryEventStatus();
class PlayerStoryEventStatus_Builder {
  constructor(value) {
    this._value = new PlayerStoryEventStatus(value);
  }
  build() {
    return new PlayerStoryEventStatus(this._value);
  }
  addAllStoryEventStatuses(values) {
    this._value._storyEventStatuses = this._value._storyEventStatuses.concat(values);
    return this;
  }
  addStoryEventStatuses(value) {
    this._value._storyEventStatuses = this._value._storyEventStatuses.concat([value]);
    return this;
  }
  setStoryEventStatuses(index, value) {
    this._value._storyEventStatuses = this._value._storyEventStatuses.concat();
    this._value._storyEventStatuses[index] = value;
    return this;
  }
  clearStoryEventStatuses() {
    this._value._storyEventStatuses = [];
    return this;
  }
}
PlayerStoryEventStatus.Builder = PlayerStoryEventStatus_Builder;
class PlayerStoryEventStatus_WithParent {
  /**
   * @param {PlayerStoryEventStatus} value
   * @param {PlayerStoryEventStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerStoryEventStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfStoryEventStatuses() {
    if (!this._selfStoryEventStatuses) {
      this._selfStoryEventStatuses = [];
      for (let i of this._value.storyEventStatuses) {
        this._selfStoryEventStatuses.push(new StoryEventStatus.WithParent(i, null));
      }
    }
    return this._selfStoryEventStatuses;
  }
  get inherentStoryEventStatuses() {
    if (!this._inherentStoryEventStatuses) {
      this._inherentStoryEventStatuses = this._parent ? this._parent.storyEventStatuses : [];
    }
    return this._inherentStoryEventStatuses;
  }
  get storyEventStatuses() {
    if (!this._allStoryEventStatuses) {
      this._allStoryEventStatuses = this._parent ? this._parent.storyEventStatuses.concat(this.selfStoryEventStatuses) : this.selfStoryEventStatuses;
    }
    return this._allStoryEventStatuses;
  }
  update(current, parent) {
    const result = new PlayerStoryEventStatus_WithParent(current, parent);
    if (this._selfStoryEventStatuses) {
      if (this._value.storyEventStatuses === current.storyEventStatuses) {
        result._selfStoryEventStatuses = this._selfStoryEventStatuses;
      } else {
        result._selfStoryEventStatuses = [];
        for (let i = 0; i < current.storyEventStatuses.length; i++) {
          const oldValue = this._value.storyEventStatuses[i];
          if (oldValue) {
            const oldCache = this._selfStoryEventStatuses[i];
            if (oldValue === current.storyEventStatuses[i]) {
              result._selfStoryEventStatuses[i] = oldCache;
            } else {
              result._selfStoryEventStatuses[i] = oldCache.update(current.storyEventStatuses[i], null);
            }
          } else {
            result._selfStoryEventStatuses[i] = new StoryEventStatus.WithParent(current.storyEventStatuses[i], null);
          }
        }
      }
    }
    return result;
  }
}
PlayerStoryEventStatus_WithParent.default = new PlayerStoryEventStatus_WithParent(PlayerStoryEventStatus.default, null);
PlayerStoryEventStatus.WithParent = PlayerStoryEventStatus_WithParent;
class PlayerStoryEventStatus_Descriptor {
  get storyEventStatuses() {
    if (!this._storyEventStatuses) {
      this._storyEventStatuses = {
        name: "storyEventStatuses",
        Name: "StoryEventStatuses",
        number: 1,
        protoType: 11,
        protoName: "story_event_statuses",
        type: StoryEventStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storyEventStatuses;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storyEventStatuses,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PlayerStoryEventStatus.descriptor = new PlayerStoryEventStatus_Descriptor();
